/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AutomatedTasksClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    automatedtaskGET(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfAutomatedTask> {
        let url_ = this.baseUrl + "/automatedtask/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutomatedtaskGET(_response);
        });
    }

    protected processAutomatedtaskGET(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfAutomatedTask> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfAutomatedTask>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfAutomatedTask>(<any>null);
    }

    /**
     * @return Success
     */
    task(id: number, storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfAutomatedTaskDetails> {
        let url_ = this.baseUrl + "/automatedtask/{storeNumber}/task/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTask(_response);
        });
    }

    protected processTask(response: AxiosResponse): Promise<SuccessResponse_1OfAutomatedTaskDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfAutomatedTaskDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfAutomatedTaskDetails>(<any>null);
    }

    /**
     * @return Success
     */
    automatedtaskDELETE(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/automatedtask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutomatedtaskDELETE(_response);
        });
    }

    protected processAutomatedtaskDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    automatedtaskPOST(body?: AutomatedTask | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/automatedtask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutomatedtaskPOST(_response);
        });
    }

    protected processAutomatedtaskPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    previewdates(body?: AutomatedTask | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate> {
        let url_ = this.baseUrl + "/automatedtask/previewdates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewdates(_response);
        });
    }

    protected processPreviewdates(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate>(<any>null);
    }
}

export class ConfigurationsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param franchiseName (optional) 
     * @param storeNumber (optional) 
     * @return Success
     */
    configurationsGET(franchiseName?: string | undefined, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetConfigurationResponse> {
        let url_ = this.baseUrl + "/configurations?";
        if (franchiseName === null)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfigurationsGET(_response);
        });
    }

    protected processConfigurationsGET(response: AxiosResponse): Promise<SuccessResponse_1OfGetConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetConfigurationResponse>(<any>null);
    }

    /**
     * @return Success
     */
    name(configurationName: ConfigurationName, storeNumber: string, franchiseName: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetConfigurationResponse> {
        let url_ = this.baseUrl + "/configurations/name?";
        if (configurationName === undefined || configurationName === null)
            throw new Error("The parameter 'configurationName' must be defined and cannot be null.");
        else
            url_ += "ConfigurationName=" + encodeURIComponent("" + configurationName) + "&";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined and cannot be null.");
        else
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (franchiseName === undefined || franchiseName === null)
            throw new Error("The parameter 'franchiseName' must be defined and cannot be null.");
        else
            url_ += "FranchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processName(_response);
        });
    }

    protected processName(response: AxiosResponse): Promise<SuccessResponse_1OfGetConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetConfigurationResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    configurationsPATCH(id: number, body?: UpdateConfigurationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/configurations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfigurationsPATCH(_response);
        });
    }

    protected processConfigurationsPATCH(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ConversionsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param search (optional) 
     * @param uomClass (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param storeNumber (optional) 
     * @return Success
     */
    conversions(search?: string | undefined, uomClass?: string | undefined, skip?: number | undefined, take?: number | undefined, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<GetConversionsResponseDto> {
        let url_ = this.baseUrl + "/conversions?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (uomClass === null)
            throw new Error("The parameter 'uomClass' cannot be null.");
        else if (uomClass !== undefined)
            url_ += "UomClass=" + encodeURIComponent("" + uomClass) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConversions(_response);
        });
    }

    protected processConversions(response: AxiosResponse): Promise<GetConversionsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetConversionsResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConversionsResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body?: ImportConversionsRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/conversions/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param itemNumber (optional) 
     * @param storeNumbers (optional) 
     * @param uom (optional) 
     * @return Success
     */
    existingconversions(itemNumber?: string | undefined, storeNumbers?: string[] | undefined, uom?: string | undefined , cancelToken?: CancelToken | undefined): Promise<GetExistingConversionsResponseDto> {
        let url_ = this.baseUrl + "/conversions/existingconversions?";
        if (itemNumber === null)
            throw new Error("The parameter 'itemNumber' cannot be null.");
        else if (itemNumber !== undefined)
            url_ += "ItemNumber=" + encodeURIComponent("" + itemNumber) + "&";
        if (storeNumbers === null)
            throw new Error("The parameter 'storeNumbers' cannot be null.");
        else if (storeNumbers !== undefined)
            storeNumbers && storeNumbers.forEach(item => { url_ += "StoreNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (uom === null)
            throw new Error("The parameter 'uom' cannot be null.");
        else if (uom !== undefined)
            url_ += "Uom=" + encodeURIComponent("" + uom) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExistingconversions(_response);
        });
    }

    protected processExistingconversions(response: AxiosResponse): Promise<GetExistingConversionsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetExistingConversionsResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetExistingConversionsResponseDto>(<any>null);
    }
}

export class DistrictsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param franchiseName (optional) 
     * @return Success
     */
    districts(franchiseName?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict> {
        let url_ = this.baseUrl + "/districts?";
        if (franchiseName === null)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDistricts(_response);
        });
    }

    protected processDistricts(response: AxiosResponse): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict>(<any>null);
    }
}

export class InternalClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param franchiseName (optional) 
     * @param storeNumber (optional) 
     * @param csvFile (optional) 
     * @return Success
     */
    updatecostpricesbyeachprice(franchiseName?: string[] | undefined, storeNumber?: string[] | undefined, csvFile?: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateCostPricesByEachPriceResponseDto> {
        let url_ = this.baseUrl + "/internal/support/updatecostpricesbyeachprice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (franchiseName === null || franchiseName === undefined)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else
            franchiseName.forEach(item_ => content_.append("FranchiseName", item_.toString()));
        if (storeNumber === null || storeNumber === undefined)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else
            storeNumber.forEach(item_ => content_.append("StoreNumber", item_.toString()));
        if (csvFile === null || csvFile === undefined)
            throw new Error("The parameter 'csvFile' cannot be null.");
        else
            content_.append("CsvFile", csvFile.data, csvFile.fileName ? csvFile.fileName : "CsvFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatecostpricesbyeachprice(_response);
        });
    }

    protected processUpdatecostpricesbyeachprice(response: AxiosResponse): Promise<UpdateCostPricesByEachPriceResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UpdateCostPricesByEachPriceResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateCostPricesByEachPriceResponseDto>(<any>null);
    }

    /**
     * @param franchiseName (optional) 
     * @param storeNumber (optional) 
     * @param csvFile (optional) 
     * @return Success
     */
    updatecostpricesbyprimaryuomprice(franchiseName?: string[] | undefined, storeNumber?: string[] | undefined, csvFile?: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateCostPricesByPrimaryUomPriceRequestDto> {
        let url_ = this.baseUrl + "/internal/support/updatecostpricesbyprimaryuomprice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (franchiseName === null || franchiseName === undefined)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else
            franchiseName.forEach(item_ => content_.append("FranchiseName", item_.toString()));
        if (storeNumber === null || storeNumber === undefined)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else
            storeNumber.forEach(item_ => content_.append("StoreNumber", item_.toString()));
        if (csvFile === null || csvFile === undefined)
            throw new Error("The parameter 'csvFile' cannot be null.");
        else
            content_.append("CsvFile", csvFile.data, csvFile.fileName ? csvFile.fileName : "CsvFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatecostpricesbyprimaryuomprice(_response);
        });
    }

    protected processUpdatecostpricesbyprimaryuomprice(response: AxiosResponse): Promise<UpdateCostPricesByPrimaryUomPriceRequestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UpdateCostPricesByPrimaryUomPriceRequestDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateCostPricesByPrimaryUomPriceRequestDto>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @param csvFile (optional) 
     * @return Success
     */
    updatecostpricesbyprimaryuompricematch(storeNumber?: string[] | undefined, csvFile?: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateCostPricesByPrimaryUomPriceMatchRequestDto> {
        let url_ = this.baseUrl + "/internal/support/updatecostpricesbyprimaryuompricematch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (storeNumber === null || storeNumber === undefined)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else
            storeNumber.forEach(item_ => content_.append("StoreNumber", item_.toString()));
        if (csvFile === null || csvFile === undefined)
            throw new Error("The parameter 'csvFile' cannot be null.");
        else
            content_.append("CsvFile", csvFile.data, csvFile.fileName ? csvFile.fileName : "CsvFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatecostpricesbyprimaryuompricematch(_response);
        });
    }

    protected processUpdatecostpricesbyprimaryuompricematch(response: AxiosResponse): Promise<UpdateCostPricesByPrimaryUomPriceMatchRequestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UpdateCostPricesByPrimaryUomPriceMatchRequestDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateCostPricesByPrimaryUomPriceMatchRequestDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatestorenumber(body?: UpdateStoreNumberRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateStoreNumberResponseDto> {
        let url_ = this.baseUrl + "/internal/support/updatestorenumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatestorenumber(_response);
        });
    }

    protected processUpdatestorenumber(response: AxiosResponse): Promise<UpdateStoreNumberResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UpdateStoreNumberResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateStoreNumberResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatequantityonhand(body?: UpdateQuantityOnHandRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateQuantityOnHandResponseDto> {
        let url_ = this.baseUrl + "/internal/support/updatequantityonhand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatequantityonhand(_response);
        });
    }

    protected processUpdatequantityonhand(response: AxiosResponse): Promise<UpdateQuantityOnHandResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UpdateQuantityOnHandResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateQuantityOnHandResponseDto>(<any>null);
    }
}

export class InvoiceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import2(body?: CreateInvoiceRequest[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/invoice/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport2(_response);
        });
    }

    protected processImport2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    reconcile(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/invoice/reconcile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReconcile(_response);
        });
    }

    protected processReconcile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @param invoiceNumber (optional) 
     * @param orderNumber (optional) 
     * @param ewsOrderNumber (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param status (optional) 
     * @param sort (optional) 
     * @param direction (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    invoiceGET(storeNumber?: string | undefined, invoiceNumber?: string | undefined, orderNumber?: string | undefined, ewsOrderNumber?: string | undefined, from?: string | undefined, to?: string | undefined, status?: string | undefined, sort?: string | undefined, direction?: string | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetInvoicesResponse> {
        let url_ = this.baseUrl + "/invoice?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (orderNumber === null)
            throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (ewsOrderNumber === null)
            throw new Error("The parameter 'ewsOrderNumber' cannot be null.");
        else if (ewsOrderNumber !== undefined)
            url_ += "EwsOrderNumber=" + encodeURIComponent("" + ewsOrderNumber) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoiceGET(_response);
        });
    }

    protected processInvoiceGET(response: AxiosResponse): Promise<SuccessResponse_1OfGetInvoicesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetInvoicesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetInvoicesResponse>(<any>null);
    }

    /**
     * @param status (optional) 
     * @param sort (optional) 
     * @param direction (optional) 
     * @return Success
     */
    invoiceGET2(invoiceId: number, status?: string | undefined, sort?: string | undefined, direction?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfInvoice> {
        let url_ = this.baseUrl + "/invoice/{invoiceId}?";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoiceGET2(_response);
        });
    }

    protected processInvoiceGET2(response: AxiosResponse): Promise<SuccessResponse_1OfInvoice> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfInvoice>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfInvoice>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    invoicePOST(invoiceId: number, body?: UpdateInvoiceRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/invoice/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoicePOST(_response);
        });
    }

    protected processInvoicePOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    invoicePOST2(invoiceId: number, invoiceItemId: number, body?: UpdateInvoiceRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/invoice/{invoiceId}/{invoiceItemId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (invoiceItemId === undefined || invoiceItemId === null)
            throw new Error("The parameter 'invoiceItemId' must be defined.");
        url_ = url_.replace("{invoiceItemId}", encodeURIComponent("" + invoiceItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoicePOST2(_response);
        });
    }

    protected processInvoicePOST2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getinvoicestatusrag(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> {
        let url_ = this.baseUrl + "/invoice/getinvoicestatusrag";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetinvoicestatusrag(_response);
        });
    }

    protected processGetinvoicestatusrag(response: AxiosResponse): Promise<SuccessResponse_1OfRAG> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfRAG>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfRAG>(<any>null);
    }

    /**
     * @return Success
     */
    getinvoicedatabyragstatus(status: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfInvoiceRag> {
        let url_ = this.baseUrl + "/invoice/getinvoicedatabyragstatus/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetinvoicedatabyragstatus(_response);
        });
    }

    protected processGetinvoicedatabyragstatus(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfInvoiceRag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfInvoiceRag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfInvoiceRag>(<any>null);
    }

    /**
     * @return Success
     */
    export(invoiceId: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/invoice/{invoiceId}/export";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ItemAndComponentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    itemandcomponentPOST(body?: UpsertItem | undefined , cancelToken?: CancelToken | undefined): Promise<Item> {
        let url_ = this.baseUrl + "/itemandcomponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItemandcomponentPOST(_response);
        });
    }

    protected processItemandcomponentPOST(response: AxiosResponse): Promise<Item> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Item>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Item>(<any>null);
    }

    /**
     * @param search (optional) 
     * @param storeNumber (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    itemandcomponentGET(search?: string | undefined, storeNumber?: string | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<PagedData_1OfRecipe> {
        let url_ = this.baseUrl + "/itemandcomponent?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItemandcomponentGET(_response);
        });
    }

    protected processItemandcomponentGET(response: AxiosResponse): Promise<PagedData_1OfRecipe> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedData_1OfRecipe>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedData_1OfRecipe>(<any>null);
    }

    /**
     * @return Success
     */
    itemandcomponentDELETE(itemId: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/itemandcomponent/{itemId}";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItemandcomponentDELETE(_response);
        });
    }

    protected processItemandcomponentDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    itemandcomponentGET2(itemId: number , cancelToken?: CancelToken | undefined): Promise<Item> {
        let url_ = this.baseUrl + "/itemandcomponent/{itemId}";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItemandcomponentGET2(_response);
        });
    }

    protected processItemandcomponentGET2(response: AxiosResponse): Promise<Item> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Item>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Item>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    componentPOST(body?: UpsertItemComponent | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/itemandcomponent/component";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComponentPOST(_response);
        });
    }

    protected processComponentPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    componentDELETE(itemId: number, componentItemId: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/itemandcomponent/{itemId}/component/{componentItemId}";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (componentItemId === undefined || componentItemId === null)
            throw new Error("The parameter 'componentItemId' must be defined.");
        url_ = url_.replace("{componentItemId}", encodeURIComponent("" + componentItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComponentDELETE(_response);
        });
    }

    protected processComponentDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    export2(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/itemandcomponent/{storeNumber}/export";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport2(_response);
        });
    }

    protected processExport2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class ItemCostHistoriesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param date (optional) 
     * @return Success
     */
    getItemCostHistoriesByItemNumber(itemNumber: string, storeNumber: string, date?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfCostHistory> {
        let url_ = this.baseUrl + "/itemcosthistories?";
        if (itemNumber === undefined || itemNumber === null)
            throw new Error("The parameter 'itemNumber' must be defined and cannot be null.");
        else
            url_ += "ItemNumber=" + encodeURIComponent("" + itemNumber) + "&";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined and cannot be null.");
        else
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemCostHistoriesByItemNumber(_response);
        });
    }

    protected processGetItemCostHistoriesByItemNumber(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfCostHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfCostHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfCostHistory>(<any>null);
    }

    /**
     * Calculates wac values for a store.
     * @param storeNumber (optional) 
     * @param costPriceModel (optional) 
     * @return Success
     */
    calculatewacforstore(storeNumber?: string | undefined, costPriceModel?: CostPriceModel | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/itemcosthistories/calculatewacforstore?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (costPriceModel === null)
            throw new Error("The parameter 'costPriceModel' cannot be null.");
        else if (costPriceModel !== undefined)
            url_ += "costPriceModel=" + encodeURIComponent("" + costPriceModel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculatewacforstore(_response);
        });
    }

    protected processCalculatewacforstore(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Updates mart with WAC values for a given month.
     * @param storeNumber (optional) 
     * @param fromDate (optional) 
     * @param costPriceModel (optional) 
     * @return Success
     */
    applywactomart(storeNumber?: string | undefined, fromDate?: string | undefined, costPriceModel?: CostPriceModel | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/itemcosthistories/applywactomart?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (costPriceModel === null)
            throw new Error("The parameter 'costPriceModel' cannot be null.");
        else if (costPriceModel !== undefined)
            url_ += "costPriceModel=" + encodeURIComponent("" + costPriceModel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplywactomart(_response);
        });
    }

    protected processApplywactomart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Updates Stock Attributes using the latest ItemsDailyPrice record per item for a store.
     * @param storeNumber (optional) 
     * @return Success
     */
    updatestockattributesfromlatestitemsdailyprice(storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/itemcosthistories/updatestockattributesfromlatestitemsdailyprice?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatestockattributesfromlatestitemsdailyprice(_response);
        });
    }

    protected processUpdatestockattributesfromlatestitemsdailyprice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ItemHistoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param date (optional) 
     * @return Success
     */
    getitemcosthistoriesbyitemnumber(itemNumber: string, storeNumber: string, date?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfCostHistory> {
        let url_ = this.baseUrl + "/itemhistory/getitemcosthistoriesbyitemnumber?";
        if (itemNumber === undefined || itemNumber === null)
            throw new Error("The parameter 'itemNumber' must be defined and cannot be null.");
        else
            url_ += "ItemNumber=" + encodeURIComponent("" + itemNumber) + "&";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined and cannot be null.");
        else
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetitemcosthistoriesbyitemnumber(_response);
        });
    }

    protected processGetitemcosthistoriesbyitemnumber(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfCostHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfCostHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfCostHistory>(<any>null);
    }

    /**
     * @return Success
     */
    getitemdailyhistory(itemNumber: string, storeNumber: string, fromDate: string, toDate: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItemDailyHistory> {
        let url_ = this.baseUrl + "/itemhistory/getitemdailyhistory?";
        if (itemNumber === undefined || itemNumber === null)
            throw new Error("The parameter 'itemNumber' must be defined and cannot be null.");
        else
            url_ += "ItemNumber=" + encodeURIComponent("" + itemNumber) + "&";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined and cannot be null.");
        else
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetitemdailyhistory(_response);
        });
    }

    protected processGetitemdailyhistory(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfItemDailyHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfItemDailyHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfItemDailyHistory>(<any>null);
    }
}

export class ItemsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param storeNumber (optional) 
     * @param withoutWeight (optional) 
     * @param withoutLiquid (optional) 
     * @return Success
     */
    getUoms(itemNumber: string, storeNumber?: string | undefined, withoutWeight?: boolean | undefined, withoutLiquid?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetUomsResponse> {
        let url_ = this.baseUrl + "/items/{itemNumber}/uoms?";
        if (itemNumber === undefined || itemNumber === null)
            throw new Error("The parameter 'itemNumber' must be defined.");
        url_ = url_.replace("{itemNumber}", encodeURIComponent("" + itemNumber));
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (withoutWeight === null)
            throw new Error("The parameter 'withoutWeight' cannot be null.");
        else if (withoutWeight !== undefined)
            url_ += "withoutWeight=" + encodeURIComponent("" + withoutWeight) + "&";
        if (withoutLiquid === null)
            throw new Error("The parameter 'withoutLiquid' cannot be null.");
        else if (withoutLiquid !== undefined)
            url_ += "withoutLiquid=" + encodeURIComponent("" + withoutLiquid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUoms(_response);
        });
    }

    protected processGetUoms(response: AxiosResponse): Promise<SuccessResponse_1OfGetUomsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetUomsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetUomsResponse>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    getByItemNumber(itemNumber: string, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfItem> {
        let url_ = this.baseUrl + "/items/{itemNumber}?";
        if (itemNumber === undefined || itemNumber === null)
            throw new Error("The parameter 'itemNumber' must be defined.");
        url_ = url_.replace("{itemNumber}", encodeURIComponent("" + itemNumber));
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByItemNumber(_response);
        });
    }

    protected processGetByItemNumber(response: AxiosResponse): Promise<SuccessResponse_1OfItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfItem>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfItem>(<any>null);
    }

    /**
     * @param search (optional) 
     * @param storeNumber (optional) 
     * @param hasRecentActivity (optional) 
     * @param isMadeInStore (optional) 
     * @param isStockItem (optional) 
     * @param isSaleItem (optional) 
     * @param isProduct (optional) 
     * @param isMaterial (optional) 
     * @param excludeRecipes (optional) 
     * @param isStockCountEnabled (optional) 
     * @param isDailyWaste (optional) 
     * @param sort (optional) 
     * @param direction (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param addItems (optional) 
     * @return Success
     */
    get(search?: string | undefined, storeNumber?: string | undefined, hasRecentActivity?: boolean | undefined, isMadeInStore?: boolean | undefined, isStockItem?: boolean | undefined, isSaleItem?: boolean | undefined, isProduct?: boolean | undefined, isMaterial?: boolean | undefined, excludeRecipes?: boolean | undefined, isStockCountEnabled?: boolean | undefined, isDailyWaste?: boolean | undefined, sort?: string | undefined, direction?: string | undefined, skip?: number | undefined, take?: number | undefined, addItems?: boolean | undefined , isNew?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetItemsResponse> {
        let url_ = this.baseUrl + "/items?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (hasRecentActivity === null)
            throw new Error("The parameter 'hasRecentActivity' cannot be null.");
        else if (hasRecentActivity !== undefined)
            url_ += "HasRecentActivity=" + encodeURIComponent("" + hasRecentActivity) + "&";
        if (isMadeInStore === null)
            throw new Error("The parameter 'isMadeInStore' cannot be null.");
        else if (isMadeInStore !== undefined)
            url_ += "IsMadeInStore=" + encodeURIComponent("" + isMadeInStore) + "&";
        if (isStockItem === null)
            throw new Error("The parameter 'isStockItem' cannot be null.");
        else if (isStockItem !== undefined)
            url_ += "IsStockItem=" + encodeURIComponent("" + isStockItem) + "&";
        if (isSaleItem === null)
            throw new Error("The parameter 'isSaleItem' cannot be null.");
        else if (isSaleItem !== undefined)
            url_ += "IsSaleItem=" + encodeURIComponent("" + isSaleItem) + "&";
        if (isProduct === null)
            throw new Error("The parameter 'isProduct' cannot be null.");
        else if (isProduct !== undefined)
            url_ += "IsProduct=" + encodeURIComponent("" + isProduct) + "&";
        if (isMaterial === null)
            throw new Error("The parameter 'isMaterial' cannot be null.");
        else if (isMaterial !== undefined)
            url_ += "IsMaterial=" + encodeURIComponent("" + isMaterial) + "&";
        if (excludeRecipes === null)
            throw new Error("The parameter 'excludeRecipes' cannot be null.");
        else if (excludeRecipes !== undefined)
            url_ += "ExcludeRecipes=" + encodeURIComponent("" + excludeRecipes) + "&";
        if (isStockCountEnabled === null)
            throw new Error("The parameter 'isStockCountEnabled' cannot be null.");
        else if (isStockCountEnabled !== undefined)
            url_ += "IsStockCountEnabled=" + encodeURIComponent("" + isStockCountEnabled) + "&";
        if (isDailyWaste === null)
            throw new Error("The parameter 'isDailyWaste' cannot be null.");
        else if (isDailyWaste !== undefined)
            url_ += "IsDailyWaste=" + encodeURIComponent("" + isDailyWaste) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (addItems === null)
            throw new Error("The parameter 'addItems' cannot be null.");
        else if (addItems !== undefined)
            url_ += "AddItems=" + encodeURIComponent("" + addItems) + "&";
        if (isNew === null)
            throw new Error("The parameter 'isNew' cannot be null.");
        else if (isNew !== undefined)
            url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SuccessResponse_1OfGetItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetItemsResponse>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetItemsResponse>(<any>null);
    }

    /**
     * @param search (optional) 
     * @param storeNumber (optional) 
     * @param hasRecentActivity (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param addItems (optional) 
     * @param purchaseOrderHeaderId (optional) 
     * @return Success
     */
    getItemsOfSupplier(search?: string | undefined, storeNumber?: string | undefined, hasRecentActivity?: boolean | undefined, skip?: number | undefined, take?: number | undefined, addItems?: boolean | undefined, purchaseOrderHeaderId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetItemsResponse> {
        let url_ = this.baseUrl + "/items/getitemsofsupplier?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (hasRecentActivity === null)
            throw new Error("The parameter 'hasRecentActivity' cannot be null.");
        else if (hasRecentActivity !== undefined)
            url_ += "HasRecentActivity=" + encodeURIComponent("" + hasRecentActivity) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (addItems === null)
            throw new Error("The parameter 'addItems' cannot be null.");
        else if (addItems !== undefined)
            url_ += "AddItems=" + encodeURIComponent("" + addItems) + "&";
        if (purchaseOrderHeaderId === null)
            throw new Error("The parameter 'purchaseOrderHeaderId' cannot be null.");
        else if (purchaseOrderHeaderId !== undefined)
            url_ += "PurchaseOrderHeaderId=" + encodeURIComponent("" + purchaseOrderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemsOfSupplier(_response);
        });
    }

    protected processGetItemsOfSupplier(response: AxiosResponse): Promise<SuccessResponse_1OfGetItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetItemsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetItemsResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getByStoreNumbers(body?: GetItemsByStoresRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> {
        let url_ = this.baseUrl + "/items/getbystorenumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByStoreNumbers(_response);
        });
    }

    protected processGetByStoreNumbers(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfItem>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfItem>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchByStoreNumbers(body?: SearchItemsByStoresRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> {
        let url_ = this.baseUrl + "/items/searchbystorenumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchByStoreNumbers(_response);
        });
    }

    protected processSearchByStoreNumbers(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfItem>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfItem>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getByIds(body?: GetItemsByIdsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> {
        let url_ = this.baseUrl + "/items/getbyids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByIds(_response);
        });
    }

    protected processGetByIds(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfItem>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getByIdsWithReasons(body?: GetItemsByIdsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> {
        let url_ = this.baseUrl + "/items/getbyidswithreasons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByIdsWithReasons(_response);
        });
    }

    protected processGetByIdsWithReasons(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfItem>(<any>null);
    }

    /**
     * @return Success
     */
    getStockItems(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> {
        let url_ = this.baseUrl + "/items/{storeNumber}/getstockitems";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStockItems(_response);
        });
    }

    protected processGetStockItems(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfItem>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfItem>(<any>null);
    }

    /**
     * @param search (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getTransferItems(search?: string | undefined, from?: string | undefined, to?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetItemsResponse> {
        let url_ = this.baseUrl + "/items/transfer?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransferItems(_response);
        });
    }

    protected processGetTransferItems(response: AxiosResponse): Promise<SuccessResponse_1OfGetItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetItemsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    addStoreFeedChanges(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/{storeNumber}/addfeedchanges";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddStoreFeedChanges(_response);
        });
    }

    protected processAddStoreFeedChanges(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addFeedChanges(body?: RefreshItemsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/addfeedchanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFeedChanges(_response);
        });
    }

    protected processAddFeedChanges(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    applyChange(itemFeedChangeId: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/{itemFeedChangeId}/applychange";
        if (itemFeedChangeId === undefined || itemFeedChangeId === null)
            throw new Error("The parameter 'itemFeedChangeId' must be defined.");
        url_ = url_.replace("{itemFeedChangeId}", encodeURIComponent("" + itemFeedChangeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyChange(_response);
        });
    }

    protected processApplyChange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    disregardChange(itemFeedChangeId: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/{itemFeedChangeId}/disregardchange";
        if (itemFeedChangeId === undefined || itemFeedChangeId === null)
            throw new Error("The parameter 'itemFeedChangeId' must be defined.");
        url_ = url_.replace("{itemFeedChangeId}", encodeURIComponent("" + itemFeedChangeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisregardChange(_response);
        });
    }

    protected processDisregardChange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyChanges(body?: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/applychanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyChanges(_response);
        });
    }

    protected processApplyChanges(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disregardChanges(body?: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/disregardchanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisregardChanges(_response);
        });
    }

    protected processDisregardChanges(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param search (optional) 
     * @param storeNumber (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param isNew (optional) 
     * @param applied (optional) 
     * @param disregarded (optional) 
     * @return Success
     */
    getRecipeChanges(search?: string | undefined, storeNumber?: string | undefined, skip?: number | undefined, take?: number | undefined, isNew?: boolean | undefined, applied?: boolean | undefined, disregarded?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<PagedData_1OfItemFeedChange> {
        let url_ = this.baseUrl + "/items/getrecipechanges?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (isNew === null)
            throw new Error("The parameter 'isNew' cannot be null.");
        else if (isNew !== undefined)
            url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
        if (applied === null)
            throw new Error("The parameter 'applied' cannot be null.");
        else if (applied !== undefined)
            url_ += "Applied=" + encodeURIComponent("" + applied) + "&";
        if (disregarded === null)
            throw new Error("The parameter 'disregarded' cannot be null.");
        else if (disregarded !== undefined)
            url_ += "Disregarded=" + encodeURIComponent("" + disregarded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecipeChanges(_response);
        });
    }

    protected processGetRecipeChanges(response: AxiosResponse): Promise<PagedData_1OfItemFeedChange> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedData_1OfItemFeedChange>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedData_1OfItemFeedChange>(<any>null);
    }

    /**
     * @param franchiseName (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getFranchiseRecipeChanges(franchiseName?: string | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<PagedData_1OfGroupedItemFeedChange> {
        let url_ = this.baseUrl + "/items/getfranchiserecipechanges?";
        if (franchiseName === null)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFranchiseRecipeChanges(_response);
        });
    }

    protected processGetFranchiseRecipeChanges(response: AxiosResponse): Promise<PagedData_1OfGroupedItemFeedChange> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedData_1OfGroupedItemFeedChange>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedData_1OfGroupedItemFeedChange>(<any>null);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getAllStoresRecipeChanges(skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<PagedData_1OfGroupedItemFeedChange> {
        let url_ = this.baseUrl + "/items/getallstoresrecipechanges?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllStoresRecipeChanges(_response);
        });
    }

    protected processGetAllStoresRecipeChanges(response: AxiosResponse): Promise<PagedData_1OfGroupedItemFeedChange> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedData_1OfGroupedItemFeedChange>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedData_1OfGroupedItemFeedChange>(<any>null);
    }

    /**
     * @return Success
     */
    getChangeDetails(itemFeedChangeId: number , cancelToken?: CancelToken | undefined): Promise<ItemCompare> {
        let url_ = this.baseUrl + "/items/{itemFeedChangeId}/changedetails";
        if (itemFeedChangeId === undefined || itemFeedChangeId === null)
            throw new Error("The parameter 'itemFeedChangeId' must be defined.");
        url_ = url_.replace("{itemFeedChangeId}", encodeURIComponent("" + itemFeedChangeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangeDetails(_response);
        });
    }

    protected processGetChangeDetails(response: AxiosResponse): Promise<ItemCompare> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemCompare>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemCompare>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRecipeChangesById(body?: GetRecipeChangesByIDRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ItemFeedChange[]> {
        let url_ = this.baseUrl + "/items/getrecipechangesbyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecipeChangesById(_response);
        });
    }

    protected processGetRecipeChangesById(response: AxiosResponse): Promise<ItemFeedChange[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemFeedChange[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemFeedChange[]>(<any>null);
    }

    /**
     * @return Success
     */
    updateStoreItemOrderTypes(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/updateitemordertypes/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStoreItemOrderTypes(_response);
        });
    }

    protected processUpdateStoreItemOrderTypes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateItemOrderTypes(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/updateitemordertypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateItemOrderTypes(_response);
        });
    }

    protected processUpdateItemOrderTypes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    itemStockOnHand(body?: ItemStockOnHandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ItemStockOnHandResponse[]> {
        let url_ = this.baseUrl + "/items/itemsstockonhand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItemStockOnHand(_response);
        });
    }

    protected processItemStockOnHand(response: AxiosResponse): Promise<ItemStockOnHandResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemStockOnHandResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemStockOnHandResponse[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    donotcountitemPOST(body?: PostStockCheckDoNotCountItemRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/donotcountitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDonotcountitemPOST(_response);
        });
    }

    protected processDonotcountitemPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    donotcountitemDELETE(body?: DeleteStockCheckDoNotCountItemRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/items/donotcountitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDonotcountitemDELETE(_response);
        });
    }

    protected processDonotcountitemDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @param searchTerm (optional) 
     * @param category (optional) 
     * @param fieldToSort (optional) 
     * @param sortDirection (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    donotcountitems(storeNumber?: string | undefined, searchTerm?: string | undefined, category?: string | undefined, fieldToSort?: string | undefined, sortDirection?: string | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetItemsResponse> {
        let url_ = this.baseUrl + "/items/donotcountitems?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (fieldToSort === null)
            throw new Error("The parameter 'fieldToSort' cannot be null.");
        else if (fieldToSort !== undefined)
            url_ += "FieldToSort=" + encodeURIComponent("" + fieldToSort) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDonotcountitems(_response);
        });
    }

    protected processDonotcountitems(response: AxiosResponse): Promise<SuccessResponse_1OfGetItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetItemsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetItemsResponse>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    export3(storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/items/donotcountitems/export?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport3(_response);
        });
    }

    protected processExport3(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class LocationsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getLocations(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfLocationResponse> {
        let url_ = this.baseUrl + "/locations/getlocations/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocations(_response);
        });
    }

    protected processGetLocations(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfLocationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfLocationResponse>(<any>null);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getlocation(locationId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfLocationResponse> {
        let url_ = this.baseUrl + "/locations/getlocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetlocation(_response);
        });
    }

    protected processGetlocation(response: AxiosResponse): Promise<SuccessResponse_1OfLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfLocationResponse>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfLocationResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createlocation(body?: LocationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPostLocationResponse> {
        let url_ = this.baseUrl + "/locations/createlocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatelocation(_response);
        });
    }

    protected processCreatelocation(response: AxiosResponse): Promise<SuccessResponse_1OfPostLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPostLocationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPostLocationResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatelocation(body?: LocationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GenericLocationResponse> {
        let url_ = this.baseUrl + "/locations/updatelocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatelocation(_response);
        });
    }

    protected processUpdatelocation(response: AxiosResponse): Promise<GenericLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GenericLocationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenericLocationResponse>(<any>null);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    deletelocation(locationId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<GenericLocationResponse> {
        let url_ = this.baseUrl + "/locations/deletelocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletelocation(_response);
        });
    }

    protected processDeletelocation(response: AxiosResponse): Promise<GenericLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GenericLocationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenericLocationResponse>(<any>null);
    }
}

export class MadeInStoreClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param search (optional) 
     * @param storeNumber (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    madeinstoreGET(search?: string | undefined, storeNumber?: string | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<PagedData_1OfMadeInStoreItem> {
        let url_ = this.baseUrl + "/madeinstore?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMadeinstoreGET(_response);
        });
    }

    protected processMadeinstoreGET(response: AxiosResponse): Promise<PagedData_1OfMadeInStoreItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedData_1OfMadeInStoreItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedData_1OfMadeInStoreItem>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    madeinstorePOST(body?: CreateMadeInStoreItemRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItemRecipeSummary> {
        let url_ = this.baseUrl + "/madeinstore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMadeinstorePOST(_response);
        });
    }

    protected processMadeinstorePOST(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfItemRecipeSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfItemRecipeSummary>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfItemRecipeSummary>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    create(body?: MadeInStoreItemRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/madeinstore/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    storeItems(body?: GetItemsRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetItemsResponseDto> {
        let url_ = this.baseUrl + "/madeinstore/store-items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStoreItems(_response);
        });
    }

    protected processStoreItems(response: AxiosResponse): Promise<SuccessResponse_1OfGetItemsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetItemsResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetItemsResponseDto>(<any>null);
    }
}

export class MaterialsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getAllMaterialsForStore(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfMaterial> {
        let url_ = this.baseUrl + "/materials/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllMaterialsForStore(_response);
        });
    }

    protected processGetAllMaterialsForStore(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfMaterial> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfMaterial>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfMaterial>(<any>null);
    }

    /**
     * @param searchTerm (optional) 
     * @param storeNumber (optional) 
     * @return Success
     */
    getByMaterialNumberOrDescription(searchTerm?: string | undefined, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfMaterial> {
        let url_ = this.baseUrl + "/materials/search?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByMaterialNumberOrDescription(_response);
        });
    }

    protected processGetByMaterialNumberOrDescription(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfMaterial> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfMaterial>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfMaterial>(<any>null);
    }

    /**
     * @param materialNumber (optional) 
     * @param storeNumber (optional) 
     * @return Success
     */
    getByMaterialNumber(materialNumber?: string | undefined, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfMaterial> {
        let url_ = this.baseUrl + "/materials/byid?";
        if (materialNumber === null)
            throw new Error("The parameter 'materialNumber' cannot be null.");
        else if (materialNumber !== undefined)
            url_ += "materialNumber=" + encodeURIComponent("" + materialNumber) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByMaterialNumber(_response);
        });
    }

    protected processGetByMaterialNumber(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfMaterial> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfMaterial>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfMaterial>(<any>null);
    }
}

export class NotificationsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getnotification(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification> {
        let url_ = this.baseUrl + "/notifications/getnotification/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetnotification(_response);
        });
    }

    protected processGetnotification(response: AxiosResponse): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification>(<any>null);
    }

    /**
     * @return Success
     */
    notificationsGET(notificationId: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSuccessResponse_1OfNotification> {
        let url_ = this.baseUrl + "/notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationsGET(_response);
        });
    }

    protected processNotificationsGET(response: AxiosResponse): Promise<SuccessResponse_1OfSuccessResponse_1OfNotification> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfNotification>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfNotification>(<any>null);
    }

    /**
     * @return No Content
     */
    notificationsDELETE(notificationId: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationsDELETE(_response);
        });
    }

    protected processNotificationsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getallnotification(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification> {
        let url_ = this.baseUrl + "/notifications/getallnotification/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetallnotification(_response);
        });
    }

    protected processGetallnotification(response: AxiosResponse): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notificationsPOST(body?: Notification | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSuccessResponse_1OfNotification> {
        let url_ = this.baseUrl + "/notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationsPOST(_response);
        });
    }

    protected processNotificationsPOST(response: AxiosResponse): Promise<SuccessResponse_1OfSuccessResponse_1OfNotification> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfNotification>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfSuccessResponse_1OfNotification>(<any>null);
    }
}

export class PaperPackagingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param franchiseId (optional) 
     * @param itemNumber (optional) 
     * @param paperPackagingType (optional) 
     * @param store (optional) 
     * @param sortField (optional) 
     * @param sortDirection (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    paperpackagingGET(franchiseId?: number | undefined, itemNumber?: string | undefined, paperPackagingType?: number | undefined, store?: string | undefined, sortField?: string | undefined, sortDirection?: string | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPagedData_1OfGetPaperPackagingResponse> {
        let url_ = this.baseUrl + "/paperpackaging?";
        if (franchiseId === null)
            throw new Error("The parameter 'franchiseId' cannot be null.");
        else if (franchiseId !== undefined)
            url_ += "FranchiseId=" + encodeURIComponent("" + franchiseId) + "&";
        if (itemNumber === null)
            throw new Error("The parameter 'itemNumber' cannot be null.");
        else if (itemNumber !== undefined)
            url_ += "ItemNumber=" + encodeURIComponent("" + itemNumber) + "&";
        if (paperPackagingType === null)
            throw new Error("The parameter 'paperPackagingType' cannot be null.");
        else if (paperPackagingType !== undefined)
            url_ += "PaperPackagingType=" + encodeURIComponent("" + paperPackagingType) + "&";
        if (store === null)
            throw new Error("The parameter 'store' cannot be null.");
        else if (store !== undefined)
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaperpackagingGET(_response);
        });
    }

    protected processPaperpackagingGET(response: AxiosResponse): Promise<SuccessResponse_1OfPagedData_1OfGetPaperPackagingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPagedData_1OfGetPaperPackagingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPagedData_1OfGetPaperPackagingResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paperpackagingPOST(body?: PostPaperPackagingRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/paperpackaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaperpackagingPOST(_response);
        });
    }

    protected processPaperpackagingPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paperpackagingPUT(body?: PutPaperPackagingRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/paperpackaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaperpackagingPUT(_response);
        });
    }

    protected processPaperpackagingPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paperpackagingDELETE(body?: DeletePaperPackagingRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/paperpackaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaperpackagingDELETE(_response);
        });
    }

    protected processPaperpackagingDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class PersonasClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param franchiseName (optional) 
     * @return Success
     */
    personasGET(franchiseName?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfPersona> {
        let url_ = this.baseUrl + "/personas?";
        if (franchiseName === null)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPersonasGET(_response);
        });
    }

    protected processPersonasGET(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfPersona> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfPersona>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfPersona>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    personasPOST(body?: PostPersonaRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/personas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPersonasPOST(_response);
        });
    }

    protected processPersonasPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    personasPUT(id: number, body?: PutPersonaRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/personas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPersonasPUT(_response);
        });
    }

    protected processPersonasPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    personasDELETE(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/personas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPersonasDELETE(_response);
        });
    }

    protected processPersonasDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param dryRun (optional) 
     * @return Success
     */
    rolesDELETE(roleId: number, dryRun?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<DeleteRoleFromPersonasResponse> {
        let url_ = this.baseUrl + "/personas/roles/{roleId}?";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (dryRun === null)
            throw new Error("The parameter 'dryRun' cannot be null.");
        else if (dryRun !== undefined)
            url_ += "dryRun=" + encodeURIComponent("" + dryRun) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRolesDELETE(_response);
        });
    }

    protected processRolesDELETE(response: AxiosResponse): Promise<DeleteRoleFromPersonasResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeleteRoleFromPersonasResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteRoleFromPersonasResponse>(<any>null);
    }

    /**
     * @param dryRun (optional) 
     * @param backgroundTask (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateauth0(dryRun?: boolean | undefined, backgroundTask?: boolean | undefined, body?: number[] | undefined, cancelToken?: CancelToken | undefined): Promise<UpdateUsersInAuth0Response> {
        let url_ = this.baseUrl + "/personas/updateauth0?";
        if (dryRun === null)
            throw new Error("The parameter 'dryRun' cannot be null.");
        else if (dryRun !== undefined)
            url_ += "dryRun=" + encodeURIComponent("" + dryRun) + "&";
        if (backgroundTask === null)
            throw new Error("The parameter 'backgroundTask' cannot be null.");
        else if (backgroundTask !== undefined)
            url_ += "backgroundTask=" + encodeURIComponent("" + backgroundTask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateauth0(_response);
        });
    }

    protected processUpdateauth0(response: AxiosResponse): Promise<UpdateUsersInAuth0Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UpdateUsersInAuth0Response>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUsersInAuth0Response>(<any>null);
    }
}

export class POSMappingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param franchiseId (optional) 
     * @param sku (optional) 
     * @param mappingType (optional) 
     * @param store (optional) 
     * @param sortField (optional) 
     * @param sortDirection (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    posmappingGET(franchiseId?: number | undefined, sku?: string | undefined, mappingType?: string | undefined, store?: string | undefined, sortField?: string | undefined, sortDirection?: string | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPagedData_1OfGetPosMappingResponse> {
        let url_ = this.baseUrl + "/posmapping?";
        if (franchiseId === null)
            throw new Error("The parameter 'franchiseId' cannot be null.");
        else if (franchiseId !== undefined)
            url_ += "FranchiseId=" + encodeURIComponent("" + franchiseId) + "&";
        if (sku === null)
            throw new Error("The parameter 'sku' cannot be null.");
        else if (sku !== undefined)
            url_ += "Sku=" + encodeURIComponent("" + sku) + "&";
        if (mappingType === null)
            throw new Error("The parameter 'mappingType' cannot be null.");
        else if (mappingType !== undefined)
            url_ += "MappingType=" + encodeURIComponent("" + mappingType) + "&";
        if (store === null)
            throw new Error("The parameter 'store' cannot be null.");
        else if (store !== undefined)
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPosmappingGET(_response);
        });
    }

    protected processPosmappingGET(response: AxiosResponse): Promise<SuccessResponse_1OfPagedData_1OfGetPosMappingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPagedData_1OfGetPosMappingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPagedData_1OfGetPosMappingResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    posmappingPOST(body?: PostPosMappingRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/posmapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPosmappingPOST(_response);
        });
    }

    protected processPosmappingPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    posmappingPUT(body?: PutPosMappingRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/posmapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPosmappingPUT(_response);
        });
    }

    protected processPosmappingPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    posmappingDELETE(body?: DeletePosMappingRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/posmapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPosmappingDELETE(_response);
        });
    }

    protected processPosmappingDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class PredictiveOrderingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param offset (optional) 
     * @return Success
     */
    predictiveorderingGET(storeNumber: string, offset?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPredictiveOrderingDetails> {
        let url_ = this.baseUrl + "/predictiveordering/{storeNumber}?";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPredictiveorderingGET(_response);
        });
    }

    protected processPredictiveorderingGET(response: AxiosResponse): Promise<SuccessResponse_1OfPredictiveOrderingDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPredictiveOrderingDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPredictiveOrderingDetails>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    predictiveorderingPOST(body?: PredictiveOrderingDetails | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPredictiveOrderingDetails> {
        let url_ = this.baseUrl + "/predictiveordering";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPredictiveorderingPOST(_response);
        });
    }

    protected processPredictiveorderingPOST(response: AxiosResponse): Promise<SuccessResponse_1OfPredictiveOrderingDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPredictiveOrderingDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPredictiveOrderingDetails>(<any>null);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    getadditionaldate(storeNumber: string, date?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPredictiveOrderingDate> {
        let url_ = this.baseUrl + "/predictiveordering/{storeNumber}/getadditionaldate?";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetadditionaldate(_response);
        });
    }

    protected processGetadditionaldate(response: AxiosResponse): Promise<SuccessResponse_1OfPredictiveOrderingDate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPredictiveOrderingDate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPredictiveOrderingDate>(<any>null);
    }

    /**
     * @param date (optional) 
     * @param body (optional) 
     * @return Success
     */
    calculateorders(storeNumber: string, date?: string | undefined, body?: PredictiveOrderingDetails | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPredictiveOrderingDate> {
        let url_ = this.baseUrl + "/predictiveordering/{storeNumber}/calculateorders?";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateorders(_response);
        });
    }

    protected processCalculateorders(response: AxiosResponse): Promise<SuccessResponse_1OfPredictiveOrderingDate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPredictiveOrderingDate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPredictiveOrderingDate>(<any>null);
    }
}

export class PrimaryCategoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    get2(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfPrimaryCategory> {
        let url_ = this.baseUrl + "/primarycategory/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfPrimaryCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfPrimaryCategory>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfPrimaryCategory>(<any>null);
    }

    /**
     * @return Success
     */
    getWithCounts(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfPrimaryCategoryStockCount> {
        let url_ = this.baseUrl + "/primarycategory/getwithcounts/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWithCounts(_response);
        });
    }

    protected processGetWithCounts(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfPrimaryCategoryStockCount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfPrimaryCategoryStockCount>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfPrimaryCategoryStockCount>(<any>null);
    }

    /**
     * @return Success
     */
    getById(id: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPrimaryCategory> {
        let url_ = this.baseUrl + "/primarycategory/getbyid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SuccessResponse_1OfPrimaryCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPrimaryCategory>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPrimaryCategory>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body?: PrimaryCategory | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPrimaryCategory> {
        let url_ = this.baseUrl + "/primarycategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<SuccessResponse_1OfPrimaryCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPrimaryCategory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPrimaryCategory>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postAddBulk(id: number, body?: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfBulkAddResponse> {
        let url_ = this.baseUrl + "/primarycategory/{id}/addbulk";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAddBulk(_response);
        });
    }

    protected processPostAddBulk(response: AxiosResponse): Promise<SuccessResponse_1OfBulkAddResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfBulkAddResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfBulkAddResponse>(<any>null);
    }

    /**
     * @return Success
     */
    applyPrimaryCategory(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/primarycategory/{storeNumber}/applyprimarycategories";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyPrimaryCategory(_response);
        });
    }

    protected processApplyPrimaryCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateCategorySalesForecast(id: number, value: boolean , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/primarycategory/{id}/forecasts/{value}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCategorySalesForecast(_response);
        });
    }

    protected processUpdateCategorySalesForecast(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateCategoryWasteCheckSheet(id: number, value: boolean , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/primarycategory/{id}/wastechecksheet/{value}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCategoryWasteCheckSheet(_response);
        });
    }

    protected processUpdateCategoryWasteCheckSheet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(storeNumber: string, id: number, substituteId: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/primarycategory/{storeNumber}/delete/{id}/substitute/{substituteId}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (substituteId === undefined || substituteId === null)
            throw new Error("The parameter 'substituteId' must be defined.");
        url_ = url_.replace("{substituteId}", encodeURIComponent("" + substituteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class PurchaseOrdersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param store (optional) 
     * @param id (optional) 
     * @param orderNumber (optional) 
     * @param packingSlip (optional) 
     * @param orderType (optional) 
     * @param supplier (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param deliveryDate (optional) 
     * @param received (optional) 
     * @param sort (optional) 
     * @param direction (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    purchaseordersGET(store?: string | undefined, id?: string | undefined, orderNumber?: string | undefined, packingSlip?: string | undefined, orderType?: string | undefined, supplier?: string | undefined, from?: string | undefined, to?: string | undefined, deliveryDate?: string | undefined, received?: boolean | undefined, sort?: string | undefined, direction?: string | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetPurchaseOrderHeadersResponse> {
        let url_ = this.baseUrl + "/purchaseorders?";
        if (store === null)
            throw new Error("The parameter 'store' cannot be null.");
        else if (store !== undefined)
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (orderNumber === null)
            throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (packingSlip === null)
            throw new Error("The parameter 'packingSlip' cannot be null.");
        else if (packingSlip !== undefined)
            url_ += "PackingSlip=" + encodeURIComponent("" + packingSlip) + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (supplier === null)
            throw new Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "Supplier=" + encodeURIComponent("" + supplier) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (deliveryDate === null)
            throw new Error("The parameter 'deliveryDate' cannot be null.");
        else if (deliveryDate !== undefined)
            url_ += "DeliveryDate=" + encodeURIComponent("" + deliveryDate) + "&";
        if (received === null)
            throw new Error("The parameter 'received' cannot be null.");
        else if (received !== undefined)
            url_ += "Received=" + encodeURIComponent("" + received) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchaseordersGET(_response);
        });
    }

    protected processPurchaseordersGET(response: AxiosResponse): Promise<SuccessResponse_1OfGetPurchaseOrderHeadersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetPurchaseOrderHeadersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetPurchaseOrderHeadersResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    purchaseordersPOST(body?: CreatePurchaseOrderHeaderRequest | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/purchaseorders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchaseordersPOST(_response);
        });
    }

    protected processPurchaseordersPOST(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<number>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param itemNumberOrDescription (optional) 
     * @param lineNumber (optional) 
     * @param sort (optional) 
     * @param direction (optional) 
     * @return Success
     */
    purchaseordersGET2(purchaseOrderHeaderId: number, itemNumberOrDescription?: string | undefined, lineNumber?: string | undefined, sort?: string | undefined, direction?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPurchaseOrderHeader> {
        let url_ = this.baseUrl + "/purchaseorders/{purchaseOrderHeaderId}?";
        if (purchaseOrderHeaderId === undefined || purchaseOrderHeaderId === null)
            throw new Error("The parameter 'purchaseOrderHeaderId' must be defined.");
        url_ = url_.replace("{purchaseOrderHeaderId}", encodeURIComponent("" + purchaseOrderHeaderId));
        if (itemNumberOrDescription === null)
            throw new Error("The parameter 'itemNumberOrDescription' cannot be null.");
        else if (itemNumberOrDescription !== undefined)
            url_ += "ItemNumberOrDescription=" + encodeURIComponent("" + itemNumberOrDescription) + "&";
        if (lineNumber === null)
            throw new Error("The parameter 'lineNumber' cannot be null.");
        else if (lineNumber !== undefined)
            url_ += "LineNumber=" + encodeURIComponent("" + lineNumber) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchaseordersGET2(_response);
        });
    }

    protected processPurchaseordersGET2(response: AxiosResponse): Promise<SuccessResponse_1OfPurchaseOrderHeader> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPurchaseOrderHeader>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPurchaseOrderHeader>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    purchaseordersPUT(purchaseOrderHeaderId: number, body?: PutPurchaseOrderHeaderRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/purchaseorders/{purchaseOrderHeaderId}";
        if (purchaseOrderHeaderId === undefined || purchaseOrderHeaderId === null)
            throw new Error("The parameter 'purchaseOrderHeaderId' must be defined.");
        url_ = url_.replace("{purchaseOrderHeaderId}", encodeURIComponent("" + purchaseOrderHeaderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchaseordersPUT(_response);
        });
    }

    protected processPurchaseordersPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param purchaseOrderHeaderId (optional) 
     * @param itemNumberOrDescription (optional) 
     * @param lineNumber (optional) 
     * @param sort (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getbyorderid(purchaseOrderHeaderId?: number | undefined, itemNumberOrDescription?: string | undefined, lineNumber?: string | undefined, sort?: string | undefined, direction?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPurchaseOrderHeader> {
        let url_ = this.baseUrl + "/purchaseorders/getbyorderid?";
        if (purchaseOrderHeaderId === null)
            throw new Error("The parameter 'purchaseOrderHeaderId' cannot be null.");
        else if (purchaseOrderHeaderId !== undefined)
            url_ += "purchaseOrderHeaderId=" + encodeURIComponent("" + purchaseOrderHeaderId) + "&";
        if (itemNumberOrDescription === null)
            throw new Error("The parameter 'itemNumberOrDescription' cannot be null.");
        else if (itemNumberOrDescription !== undefined)
            url_ += "ItemNumberOrDescription=" + encodeURIComponent("" + itemNumberOrDescription) + "&";
        if (lineNumber === null)
            throw new Error("The parameter 'lineNumber' cannot be null.");
        else if (lineNumber !== undefined)
            url_ += "LineNumber=" + encodeURIComponent("" + lineNumber) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyorderid(_response);
        });
    }

    protected processGetbyorderid(response: AxiosResponse): Promise<SuccessResponse_1OfPurchaseOrderHeader> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPurchaseOrderHeader>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPurchaseOrderHeader>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    many(body?: CreatePurchaseOrderHeaderRequest[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/purchaseorders/many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMany(_response);
        });
    }

    protected processMany(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param purchaseOrderHeaderId (optional) 
     * @return Success
     */
    isreceivingpurchaseorder(purchaseOrderHeaderId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/purchaseorders/isreceivingpurchaseorder?";
        if (purchaseOrderHeaderId === null)
            throw new Error("The parameter 'purchaseOrderHeaderId' cannot be null.");
        else if (purchaseOrderHeaderId !== undefined)
            url_ += "purchaseOrderHeaderId=" + encodeURIComponent("" + purchaseOrderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsreceivingpurchaseorder(_response);
        });
    }

    protected processIsreceivingpurchaseorder(response: AxiosResponse): Promise<SuccessResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfBoolean>(<any>null);
    }

    /**
     * @return Success
     */
    rag(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> {
        let url_ = this.baseUrl + "/purchaseorders/rag";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRag(_response);
        });
    }

    protected processRag(response: AxiosResponse): Promise<SuccessResponse_1OfRAG> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfRAG>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfRAG>(<any>null);
    }

    /**
     * @return Success
     */
    getbyragstatus(status: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag> {
        let url_ = this.baseUrl + "/purchaseorders/getbyragstatus/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyragstatus(_response);
        });
    }

    protected processGetbyragstatus(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    adjust(id: number, body?: AdjustPurchaseOrderRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/purchaseorders/adjust/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdjust(_response);
        });
    }

    protected processAdjust(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getOrderTypes(franchiseName: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfOrderTypesResponse> {
        let url_ = this.baseUrl + "/purchaseorders/getordertypes/{franchiseName}";
        if (franchiseName === undefined || franchiseName === null)
            throw new Error("The parameter 'franchiseName' must be defined.");
        url_ = url_.replace("{franchiseName}", encodeURIComponent("" + franchiseName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderTypes(_response);
        });
    }

    protected processGetOrderTypes(response: AxiosResponse): Promise<SuccessResponse_1OfOrderTypesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfOrderTypesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfOrderTypesResponse>(<any>null);
    }

    /**
     * @param franchiseName (optional) 
     * @param storeNumber (optional) 
     * @return Success
     */
    getPurchaseOrderSuppliers(franchiseName?: string | undefined, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSupplierResponse> {
        let url_ = this.baseUrl + "/purchaseorders/getpurchaseordersuppliers?";
        if (franchiseName === null)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPurchaseOrderSuppliers(_response);
        });
    }

    protected processGetPurchaseOrderSuppliers(response: AxiosResponse): Promise<SuccessResponse_1OfSupplierResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfSupplierResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfSupplierResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    additemsinpurchaseorder(body?: AddItemsInPurchaseOrderRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/purchaseorders/additemsinpurchaseorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdditemsinpurchaseorder(_response);
        });
    }

    protected processAdditemsinpurchaseorder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculatediscrepancies(storeNumber: string, body?: CalculateDiscrepanciesLine[] | undefined , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/purchaseorders/calculatediscrepancies/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculatediscrepancies(_response);
        });
    }

    protected processCalculatediscrepancies(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    begincreditrequest(body?: BeginCreditReqRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GenericCreditRequestResponse> {
        let url_ = this.baseUrl + "/purchaseorders/begincreditrequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBegincreditrequest(_response);
        });
    }

    protected processBegincreditrequest(response: AxiosResponse): Promise<GenericCreditRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GenericCreditRequestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenericCreditRequestResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendcreditrequest(body?: SendCreditReqRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GenericCreditRequestResponse> {
        let url_ = this.baseUrl + "/purchaseorders/sendcreditrequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendcreditrequest(_response);
        });
    }

    protected processSendcreditrequest(response: AxiosResponse): Promise<GenericCreditRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GenericCreditRequestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenericCreditRequestResponse>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    getcreditrequestcutoff(ewsOrderNumber: string, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/purchaseorders/getcreditrequestcutoff/{ewsOrderNumber}?";
        if (ewsOrderNumber === undefined || ewsOrderNumber === null)
            throw new Error("The parameter 'ewsOrderNumber' must be defined.");
        url_ = url_.replace("{ewsOrderNumber}", encodeURIComponent("" + ewsOrderNumber));
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetcreditrequestcutoff(_response);
        });
    }

    protected processGetcreditrequestcutoff(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    getcreditrequeststatusrag(storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> {
        let url_ = this.baseUrl + "/purchaseorders/getcreditrequeststatusrag?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetcreditrequeststatusrag(_response);
        });
    }

    protected processGetcreditrequeststatusrag(response: AxiosResponse): Promise<SuccessResponse_1OfRAG> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfRAG>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfRAG>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    getcreditrequeststatusdatabyrag(status: number, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestRag> {
        let url_ = this.baseUrl + "/purchaseorders/getcreditrequeststatusdatabyrag/{status}?";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetcreditrequeststatusdatabyrag(_response);
        });
    }

    protected processGetcreditrequeststatusdatabyrag(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestRag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfCreditRequestRag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfCreditRequestRag>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @param showAllStores (optional) 
     * @return Success
     */
    getcreditrequestvaluedata(storeNumber?: string | undefined, showAllStores?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestValue> {
        let url_ = this.baseUrl + "/purchaseorders/getcreditrequestvaluedata?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (showAllStores === null)
            throw new Error("The parameter 'showAllStores' cannot be null.");
        else if (showAllStores !== undefined)
            url_ += "ShowAllStores=" + encodeURIComponent("" + showAllStores) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetcreditrequestvaluedata(_response);
        });
    }

    protected processGetcreditrequestvaluedata(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestValue> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfCreditRequestValue>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfCreditRequestValue>(<any>null);
    }

    /**
     * @param purchaseOrderHeaderId (optional) 
     * @return Success
     */
    allownewreturntovendorrequest(purchaseOrderHeaderId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/purchaseorders/allownewreturntovendorrequest?";
        if (purchaseOrderHeaderId === null)
            throw new Error("The parameter 'purchaseOrderHeaderId' cannot be null.");
        else if (purchaseOrderHeaderId !== undefined)
            url_ += "purchaseOrderHeaderId=" + encodeURIComponent("" + purchaseOrderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllownewreturntovendorrequest(_response);
        });
    }

    protected processAllownewreturntovendorrequest(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getPurchaseOrdersCreditRequests(purchaseOrderHeaderId: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestsValuesResponse> {
        let url_ = this.baseUrl + "/purchaseorders/getpurchaseorderscreditrequests/{purchaseOrderHeaderId}";
        if (purchaseOrderHeaderId === undefined || purchaseOrderHeaderId === null)
            throw new Error("The parameter 'purchaseOrderHeaderId' must be defined.");
        url_ = url_.replace("{purchaseOrderHeaderId}", encodeURIComponent("" + purchaseOrderHeaderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPurchaseOrdersCreditRequests(_response);
        });
    }

    protected processGetPurchaseOrdersCreditRequests(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestsValuesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfCreditRequestsValuesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfCreditRequestsValuesResponse>(<any>null);
    }

    /**
     * @param returnToVendorId (optional) 
     * @return Success
     */
    getreturntovendordetails(returnToVendorId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfReturnToVendorHeaders> {
        let url_ = this.baseUrl + "/purchaseorders/getreturntovendordetails?";
        if (returnToVendorId === null)
            throw new Error("The parameter 'returnToVendorId' cannot be null.");
        else if (returnToVendorId !== undefined)
            url_ += "returnToVendorId=" + encodeURIComponent("" + returnToVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetreturntovendordetails(_response);
        });
    }

    protected processGetreturntovendordetails(response: AxiosResponse): Promise<SuccessResponse_1OfReturnToVendorHeaders> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfReturnToVendorHeaders>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfReturnToVendorHeaders>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postreturntovendor(body?: ReturnToVendorRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPostReturnToVendorResponse> {
        let url_ = this.baseUrl + "/purchaseorders/postreturntovendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostreturntovendor(_response);
        });
    }

    protected processPostreturntovendor(response: AxiosResponse): Promise<SuccessResponse_1OfPostReturnToVendorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPostReturnToVendorResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPostReturnToVendorResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendreturntovendorrequest(body?: SendCreditReqRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GenericCreditRequestResponse> {
        let url_ = this.baseUrl + "/purchaseorders/sendreturntovendorrequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendreturntovendorrequest(_response);
        });
    }

    protected processSendreturntovendorrequest(response: AxiosResponse): Promise<GenericCreditRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GenericCreditRequestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenericCreditRequestResponse>(<any>null);
    }

    /**
     * @param purchaseOrderHeaderId (optional) 
     * @return Success
     */
    getLocalTime(purchaseOrderHeaderId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfDateTime> {
        let url_ = this.baseUrl + "/purchaseorders/getlocaltime?";
        if (purchaseOrderHeaderId === null)
            throw new Error("The parameter 'purchaseOrderHeaderId' cannot be null.");
        else if (purchaseOrderHeaderId !== undefined)
            url_ += "purchaseOrderHeaderId=" + encodeURIComponent("" + purchaseOrderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocalTime(_response);
        });
    }

    protected processGetLocalTime(response: AxiosResponse): Promise<SuccessResponse_1OfDateTime> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfDateTime>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfDateTime>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    saveSuppliers(body?: PostSuppliersRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/purchaseorders/suppliers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSuppliers(_response);
        });
    }

    protected processSaveSuppliers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    saveReturnablePackagingItems(body?: PostReturnablePackagingItemsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/purchaseorders/returnablepackagingitems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveReturnablePackagingItems(_response);
        });
    }

    protected processSaveReturnablePackagingItems(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param franchiseName (optional) 
     * @param orderType (optional) 
     * @return Success
     */
    getfranchiseordertypestatus(franchiseName?: string | undefined, orderType?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfFranchiseOrderTypes> {
        let url_ = this.baseUrl + "/purchaseorders/getfranchiseordertypestatus?";
        if (franchiseName === null)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "orderType=" + encodeURIComponent("" + orderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetfranchiseordertypestatus(_response);
        });
    }

    protected processGetfranchiseordertypestatus(response: AxiosResponse): Promise<SuccessResponse_1OfFranchiseOrderTypes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfFranchiseOrderTypes>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfFranchiseOrderTypes>(<any>null);
    }
}

export class ReportBuilderClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    get4(storeNumber?: string | undefined, userId?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfReportsResponse> {
        let url_ = this.baseUrl + "/reportbuilder?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet3(_response);
        });
    }

    protected processGet3(response: AxiosResponse): Promise<SuccessResponse_1OfReportsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfReportsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfReportsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getReportById(id: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfReportDto> {
        let url_ = this.baseUrl + "/reportbuilder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportById(_response);
        });
    }

    protected processGetReportById(response: AxiosResponse): Promise<SuccessResponse_1OfReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfReportDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteReport(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reportbuilder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReport(_response);
        });
    }

    protected processDeleteReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param currentStoreNumber (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateReport(id: number, currentStoreNumber?: string | undefined, body?: ReportDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reportbuilder/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (currentStoreNumber === null)
            throw new Error("The parameter 'currentStoreNumber' cannot be null.");
        else if (currentStoreNumber !== undefined)
            url_ += "currentStoreNumber=" + encodeURIComponent("" + currentStoreNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReport(_response);
        });
    }

    protected processUpdateReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDataGroups(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIList_1OfDataGroupDto> {
        let url_ = this.baseUrl + "/reportbuilder/data-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataGroups(_response);
        });
    }

    protected processGetDataGroups(response: AxiosResponse): Promise<SuccessResponse_1OfIList_1OfDataGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIList_1OfDataGroupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIList_1OfDataGroupDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLogicalOperators(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIList_1OfLogicalOperatorDto> {
        let url_ = this.baseUrl + "/reportbuilder/logical-operators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogicalOperators(_response);
        });
    }

    protected processGetLogicalOperators(response: AxiosResponse): Promise<SuccessResponse_1OfIList_1OfLogicalOperatorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIList_1OfLogicalOperatorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIList_1OfLogicalOperatorDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFiltersOperators(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIList_1OfFilterOperatorsDto> {
        let url_ = this.baseUrl + "/reportbuilder/filter-operators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFiltersOperators(_response);
        });
    }

    protected processGetFiltersOperators(response: AxiosResponse): Promise<SuccessResponse_1OfIList_1OfFilterOperatorsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIList_1OfFilterOperatorsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIList_1OfFilterOperatorsDto>(<any>null);
    }

    /**
     * @return Success
     */
    getOperatorsForMetric(metricDataType: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIList_1OfFilterOperatorsDto> {
        let url_ = this.baseUrl + "/reportbuilder/filter-operators/{metricDataType}";
        if (metricDataType === undefined || metricDataType === null)
            throw new Error("The parameter 'metricDataType' must be defined.");
        url_ = url_.replace("{metricDataType}", encodeURIComponent("" + metricDataType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOperatorsForMetric(_response);
        });
    }

    protected processGetOperatorsForMetric(response: AxiosResponse): Promise<SuccessResponse_1OfIList_1OfFilterOperatorsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIList_1OfFilterOperatorsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIList_1OfFilterOperatorsDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFilterMetrics(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIList_1OfFilterMetricDto> {
        let url_ = this.baseUrl + "/reportbuilder/filter-metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilterMetrics(_response);
        });
    }

    protected processGetFilterMetrics(response: AxiosResponse): Promise<SuccessResponse_1OfIList_1OfFilterMetricDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIList_1OfFilterMetricDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIList_1OfFilterMetricDto>(<any>null);
    }

    /**
     * @return Success
     */
    getReportAggregations(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIList_1OfAggregationsDto> {
        let url_ = this.baseUrl + "/reportbuilder/report-aggregations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportAggregations(_response);
        });
    }

    protected processGetReportAggregations(response: AxiosResponse): Promise<SuccessResponse_1OfIList_1OfAggregationsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIList_1OfAggregationsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIList_1OfAggregationsDto>(<any>null);
    }

    /**
     * @return Success
     */
    getColumnMetrics(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIList_1OfColumnMetricDto> {
        let url_ = this.baseUrl + "/reportbuilder/column-metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetColumnMetrics(_response);
        });
    }

    protected processGetColumnMetrics(response: AxiosResponse): Promise<SuccessResponse_1OfIList_1OfColumnMetricDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIList_1OfColumnMetricDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIList_1OfColumnMetricDto>(<any>null);
    }

    /**
     * @param currentStoreNumber (optional) 
     * @param body (optional) 
     * @return Success
     */
    createReport(currentStoreNumber?: string | undefined, body?: ReportDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reportbuilder/createreport?";
        if (currentStoreNumber === null)
            throw new Error("The parameter 'currentStoreNumber' cannot be null.");
        else if (currentStoreNumber !== undefined)
            url_ += "currentStoreNumber=" + encodeURIComponent("" + currentStoreNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReport(_response);
        });
    }

    protected processCreateReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param currentStoreNumber (optional) 
     * @return Success
     */
    getDuplicateReportData(reportId: number, currentStoreNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfReportDto> {
        let url_ = this.baseUrl + "/reportbuilder/getduplicatereportdata/{reportId}?";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (currentStoreNumber === null)
            throw new Error("The parameter 'currentStoreNumber' cannot be null.");
        else if (currentStoreNumber !== undefined)
            url_ += "currentStoreNumber=" + encodeURIComponent("" + currentStoreNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDuplicateReportData(_response);
        });
    }

    protected processGetDuplicateReportData(response: AxiosResponse): Promise<SuccessResponse_1OfReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfReportDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    generateReport(body?: GenerateReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfObject> {
        let url_ = this.baseUrl + "/reportbuilder/generatereport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateReport(_response);
        });
    }

    protected processGenerateReport(response: AxiosResponse): Promise<SuccessResponse_1OfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = JSON.parse(resultData202);
            return Promise.resolve<SuccessResponse_1OfObject>(result202);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfObject>(<any>null);
    }
}

export class ReportsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    get4(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetReportsResponse> {
        let url_ = this.baseUrl + "/reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet4(_response);
        });
    }

    protected processGet4(response: AxiosResponse): Promise<SuccessResponse_1OfGetReportsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetReportsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetReportsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getReport(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getStockCountReportById(stockCountId: number , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reports/stock-count/{stockCountId}";
        if (stockCountId === undefined || stockCountId === null)
            throw new Error("The parameter 'stockCountId' must be defined.");
        url_ = url_.replace("{stockCountId}", encodeURIComponent("" + stockCountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStockCountReportById(_response);
        });
    }

    protected processGetStockCountReportById(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getExtendedStockCheckReportByIdAsPdf(stockCheckId: number , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reports/extended-stock-check/{stockCheckId}";
        if (stockCheckId === undefined || stockCheckId === null)
            throw new Error("The parameter 'stockCheckId' must be defined.");
        url_ = url_.replace("{stockCheckId}", encodeURIComponent("" + stockCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExtendedStockCheckReportByIdAsPdf(_response);
        });
    }

    protected processGetExtendedStockCheckReportByIdAsPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getItemHistoryReportById(body?: RequestItemHistoryReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reports/item-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemHistoryReportById(_response);
        });
    }

    protected processGetItemHistoryReportById(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getTheoryActualReport(body?: RequestTheoryActualReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/theoryactual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTheoryActualReport(_response);
        });
    }

    protected processGetTheoryActualReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getStockCountsVsUsageReport(body?: RequestStockCountsVsUsageReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/stockcountsvsusage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStockCountsVsUsageReport(_response);
        });
    }

    protected processGetStockCountsVsUsageReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getStockOnHandReport(body?: StockOnHandReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/stockonhand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStockOnHandReport(_response);
        });
    }

    protected processGetStockOnHandReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getWasteReport(body?: WasteReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/waste";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWasteReport(_response);
        });
    }

    protected processGetWasteReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getItemActivityReport(body?: ItemActivityReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/itemactivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemActivityReport(_response);
        });
    }

    protected processGetItemActivityReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getTransfersReport(body?: TransfersReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/transfers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransfersReport(_response);
        });
    }

    protected processGetTransfersReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumbers (optional) 
     * @param districtIds (optional) 
     * @param allStores (optional) 
     * @param numberOfWeeks (optional) 
     * @return Success
     */
    getAvailableReportingDates(storeNumbers?: string | undefined, districtIds?: string | undefined, allStores?: boolean | undefined, numberOfWeeks?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfDateTime> {
        let url_ = this.baseUrl + "/reports/availabledates?";
        if (storeNumbers === null)
            throw new Error("The parameter 'storeNumbers' cannot be null.");
        else if (storeNumbers !== undefined)
            url_ += "StoreNumbers=" + encodeURIComponent("" + storeNumbers) + "&";
        if (districtIds === null)
            throw new Error("The parameter 'districtIds' cannot be null.");
        else if (districtIds !== undefined)
            url_ += "DistrictIds=" + encodeURIComponent("" + districtIds) + "&";
        if (allStores === null)
            throw new Error("The parameter 'allStores' cannot be null.");
        else if (allStores !== undefined)
            url_ += "AllStores=" + encodeURIComponent("" + allStores) + "&";
        if (numberOfWeeks === null)
            throw new Error("The parameter 'numberOfWeeks' cannot be null.");
        else if (numberOfWeeks !== undefined)
            url_ += "NumberOfWeeks=" + encodeURIComponent("" + numberOfWeeks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableReportingDates(_response);
        });
    }

    protected processGetAvailableReportingDates(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfDateTime> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfDateTime>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfDateTime>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getItemTimeOutReport(body?: ItemTimeOutRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/itemtimeout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemTimeOutReport(_response);
        });
    }

    protected processGetItemTimeOutReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getMadeInStoreReport(body?: MadeInStoreReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/madeinstore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMadeInStoreReport(_response);
        });
    }

    protected processGetMadeInStoreReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getCostOfSalesReport(body?: CostOfSalesRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/costofsales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCostOfSalesReport(_response);
        });
    }

    protected processGetCostOfSalesReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getStockDaysReport(body?: StockDaysRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/stockdays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStockDaysReport(_response);
        });
    }

    protected processGetStockDaysReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param userLevel (optional) 
     * @return Success
     */
    getActualTheorySummaries(from?: string | undefined, to?: string | undefined, userLevel?: string | undefined , cancelToken?: CancelToken | undefined): Promise<ActualTheorySummary[]> {
        let url_ = this.baseUrl + "/reports/getactualtheorysummaries?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (userLevel === null)
            throw new Error("The parameter 'userLevel' cannot be null.");
        else if (userLevel !== undefined)
            url_ += "userLevel=" + encodeURIComponent("" + userLevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActualTheorySummaries(_response);
        });
    }

    protected processGetActualTheorySummaries(response: AxiosResponse): Promise<ActualTheorySummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ActualTheorySummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActualTheorySummary[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getInvoiceReconciliationReport(body?: InvoiceReconciliationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceReconciliationReport(_response);
        });
    }

    protected processGetInvoiceReconciliationReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getStockCountSummaryReport(body?: StockCountSummaryReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/stockcountsummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStockCountSummaryReport(_response);
        });
    }

    protected processGetStockCountSummaryReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getProductMarginReport(body?: ProductMarginReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/productmargin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductMarginReport(_response);
        });
    }

    protected processGetProductMarginReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getCreditPurchaseReport(body?: CreditPurchaseReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/creditpurchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCreditPurchaseReport(_response);
        });
    }

    protected processGetCreditPurchaseReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getExtendedStockCountReport(body?: ExtendedStockCountReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/extendedstockcount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExtendedStockCountReport(_response);
        });
    }

    protected processGetExtendedStockCountReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getDcShortageReport(body?: DcShortageReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/dcshortage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDcShortageReport(_response);
        });
    }

    protected processGetDcShortageReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getConstrainedItemReport(body?: ConstrainedItemReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/constraineditem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConstrainedItemReport(_response);
        });
    }

    protected processGetConstrainedItemReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getItemStockOutReport(body?: ItemStockOutRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/itemstockout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemStockOutReport(_response);
        });
    }

    protected processGetItemStockOutReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getReceiptsReport(body?: ReceiptsReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/receiptsreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReceiptsReport(_response);
        });
    }

    protected processGetReceiptsReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getAmRestReceiptsReport(body?: ReceiptsReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/amrestreceiptsreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAmRestReceiptsReport(_response);
        });
    }

    protected processGetAmRestReceiptsReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getCheckReport(body?: CheckReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/checkreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCheckReport(_response);
        });
    }

    protected processGetCheckReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getCOGsReport(body?: RequestCOGsReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/cogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCOGsReport(_response);
        });
    }

    protected processGetCOGsReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getItemUsageReport(body?: ItemUsageReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/itemusagereport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemUsageReport(_response);
        });
    }

    protected processGetItemUsageReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getReturnablePackagingReport(body?: ReturnablePackagingReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/returnablepackagingreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReturnablePackagingReport(_response);
        });
    }

    protected processGetReturnablePackagingReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Accepted
     */
    getSystemAuditingReport(body?: RequestSystemAuditingReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/run/systemauditing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSystemAuditingReport(_response);
        });
    }

    protected processGetSystemAuditingReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getUserReports(userId: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetReportsResponse> {
        let url_ = this.baseUrl + "/reports/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserReports(_response);
        });
    }

    protected processGetUserReports(response: AxiosResponse): Promise<SuccessResponse_1OfGetReportsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetReportsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetReportsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getUserReport(userId: number, id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reports/user/{userId}/report/{id}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserReport(_response);
        });
    }

    protected processGetUserReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getPoDetailsAsPdf(poId: number , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reports/po-details/{poId}";
        if (poId === undefined || poId === null)
            throw new Error("The parameter 'poId' must be defined.");
        url_ = url_.replace("{poId}", encodeURIComponent("" + poId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPoDetailsAsPdf(_response);
        });
    }

    protected processGetPoDetailsAsPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDoNotCountItemsFromReport(storeNumber: string, body?: UploadDoNotCountItemsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UploadDoNotCountItemsResponse> {
        let url_ = this.baseUrl + "/reports/updatedonotcountitemsfromreport/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDoNotCountItemsFromReport(_response);
        });
    }

    protected processUpdateDoNotCountItemsFromReport(response: AxiosResponse): Promise<UploadDoNotCountItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = JSON.parse(resultData202);
            return Promise.resolve<UploadDoNotCountItemsResponse>(result202);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UploadDoNotCountItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadDoNotCountItemsResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkDoNotCountFileHasData(body?: UploadDoNotCountItemsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/reports/checkdonotcountfilehasdata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckDoNotCountFileHasData(_response);
        });
    }

    protected processCheckDoNotCountFileHasData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            const result200 = typeof _responseText === 'string' ? JSON.parse(_responseText) : _responseText;
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(false);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    getAIPerformanceReport(body?: AIPerformanceReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/pod/performance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAIPerformanceReport(_response);
        });
    }

    protected processGetAIPerformanceReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param type (optional) 
     * @param storeNumber (optional) 
     * @return Success
     */
    widget(type?: PodWidgetType | undefined, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<PodWidgetData> {
        let url_ = this.baseUrl + "/reports/pod/widget?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWidget(_response);
        });
    }

    protected processWidget(response: AxiosResponse): Promise<PodWidgetData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PodWidgetData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PodWidgetData>(<any>null);
    }

    /**
     * @return Success
     */
    testGenerateReport(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestGenerateReport(_response);
        });
    }

    protected processTestGenerateReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    testGenerateIntegration(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/testintegration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestGenerateIntegration(_response);
        });
    }

    protected processTestGenerateIntegration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    testIntegrationTransactionFacts(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/test/integration/transactionfacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestIntegrationTransactionFacts(_response);
        });
    }

    protected processTestIntegrationTransactionFacts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    testGintWaves(gintWave: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/reports/testgintwaves/{gintWave}";
        if (gintWave === undefined || gintWave === null)
            throw new Error("The parameter 'gintWave' must be defined.");
        url_ = url_.replace("{gintWave}", encodeURIComponent("" + gintWave));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestGintWaves(_response);
        });
    }

    protected processTestGintWaves(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class RolesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    rolesGET(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString> {
        let url_ = this.baseUrl + "/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRolesGET(_response);
        });
    }

    protected processRolesGET(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString>(<any>null);
    }

    /**
     * @return Success
     */
    reminderroles(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString> {
        let url_ = this.baseUrl + "/roles/reminderroles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReminderroles(_response);
        });
    }

    protected processReminderroles(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString>(<any>null);
    }
}

export class SalesForecastingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getItemCategories(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<GetItemCategoriesResponseDto> {
        let url_ = this.baseUrl + "/salesforecasting/{storeNumber}/itemcategories";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemCategories(_response);
        });
    }

    protected processGetItemCategories(response: AxiosResponse): Promise<GetItemCategoriesResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetItemCategoriesResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetItemCategoriesResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getWeekPeriods(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<GetWeekPeriodsResponseDto> {
        let url_ = this.baseUrl + "/salesforecasting/{storeNumber}/weekperiods";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeekPeriods(_response);
        });
    }

    protected processGetWeekPeriods(response: AxiosResponse): Promise<GetWeekPeriodsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetWeekPeriodsResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWeekPeriodsResponseDto>(<any>null);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param itemCategory (optional) 
     * @param weekPeriod (optional) 
     * @param searchText (optional) 
     * @return Success
     */
    getForecast(storeNumber: string, skip?: number | undefined, take?: number | undefined, itemCategory?: number | undefined, weekPeriod?: number | undefined, searchText?: string | undefined , cancelToken?: CancelToken | undefined): Promise<GetForecastResponseDto> {
        let url_ = this.baseUrl + "/salesforecasting/{storeNumber}/forecast?";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (itemCategory === null)
            throw new Error("The parameter 'itemCategory' cannot be null.");
        else if (itemCategory !== undefined)
            url_ += "itemCategory=" + encodeURIComponent("" + itemCategory) + "&";
        if (weekPeriod === null)
            throw new Error("The parameter 'weekPeriod' cannot be null.");
        else if (weekPeriod !== undefined)
            url_ += "weekPeriod=" + encodeURIComponent("" + weekPeriod) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForecast(_response);
        });
    }

    protected processGetForecast(response: AxiosResponse): Promise<GetForecastResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetForecastResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetForecastResponseDto>(<any>null);
    }
}

export class SourceTransactionsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    sourcetransactions(store: string, sourceTransactionID: string, transactionDate: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetSourceTransactionsResponse> {
        let url_ = this.baseUrl + "/sourcetransactions?";
        if (store === undefined || store === null)
            throw new Error("The parameter 'store' must be defined and cannot be null.");
        else
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (sourceTransactionID === undefined || sourceTransactionID === null)
            throw new Error("The parameter 'sourceTransactionID' must be defined and cannot be null.");
        else
            url_ += "SourceTransactionID=" + encodeURIComponent("" + sourceTransactionID) + "&";
        if (transactionDate === undefined || transactionDate === null)
            throw new Error("The parameter 'transactionDate' must be defined and cannot be null.");
        else
            url_ += "TransactionDate=" + encodeURIComponent("" + transactionDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSourcetransactions(_response);
        });
    }

    protected processSourcetransactions(response: AxiosResponse): Promise<SuccessResponse_1OfGetSourceTransactionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetSourceTransactionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetSourceTransactionsResponse>(<any>null);
    }
}

export class StockClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param storeNumber (optional) 
     * @param search (optional) 
     * @param fieldToSort (optional) 
     * @param sortDirection (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param filters (optional) 
     * @param categoryFilters (optional) 
     * @param storeFilters (optional) 
     * @param hasRecentActivity (optional) 
     * @param isMadeInStore (optional) 
     * @return Success
     */
    stockGET(storeNumber?: string | undefined, search?: string | undefined, fieldToSort?: string | undefined, sortDirection?: string | undefined, skip?: number | undefined, take?: number | undefined, filters?: string | undefined, categoryFilters?: string | undefined, storeFilters?: string | undefined, hasRecentActivity?: boolean | undefined, isMadeInStore?: boolean | undefined , isNew?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetStockResponse> {
        let url_ = this.baseUrl + "/stock?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (fieldToSort === null)
            throw new Error("The parameter 'fieldToSort' cannot be null.");
        else if (fieldToSort !== undefined)
            url_ += "FieldToSort=" + encodeURIComponent("" + fieldToSort) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (categoryFilters === null)
            throw new Error("The parameter 'categoryFilters' cannot be null.");
        else if (categoryFilters !== undefined)
            url_ += "CategoryFilters=" + encodeURIComponent("" + categoryFilters) + "&";
        if (storeFilters === null)
            throw new Error("The parameter 'storeFilters' cannot be null.");
        else if (storeFilters !== undefined)
            url_ += "StoreFilters=" + encodeURIComponent("" + storeFilters) + "&";
        if (hasRecentActivity === null)
            throw new Error("The parameter 'hasRecentActivity' cannot be null.");
        else if (hasRecentActivity !== undefined)
            url_ += "HasRecentActivity=" + encodeURIComponent("" + hasRecentActivity) + "&";
        if (isMadeInStore === null)
            throw new Error("The parameter 'isMadeInStore' cannot be null.");
        else if (isMadeInStore !== undefined)
            url_ += "IsMadeInStore=" + encodeURIComponent("" + isMadeInStore) + "&";
        if (isNew === null)
            throw new Error("The parameter 'isNew' cannot be null.");
        else if (isNew !== undefined)
            url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockGET(_response);
        });
    }

    protected processStockGET(response: AxiosResponse): Promise<SuccessResponse_1OfGetStockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetStockResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetStockResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stockPUT(body?: PutStockRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockPUT(_response);
        });
    }

    protected processStockPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    stockGET2(itemNumber: string, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStockItem> {
        let url_ = this.baseUrl + "/stock/{itemNumber}?";
        if (itemNumber === undefined || itemNumber === null)
            throw new Error("The parameter 'itemNumber' must be defined.");
        url_ = url_.replace("{itemNumber}", encodeURIComponent("" + itemNumber));
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockGET2(_response);
        });
    }

    protected processStockGET2(response: AxiosResponse): Promise<SuccessResponse_1OfStockItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfStockItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfStockItem>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    updateMissingPrices(storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stock/update-missing-prices?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMissingPrices(_response);
        });
    }

    protected processUpdateMissingPrices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    updateMissingPricesV2(storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stock/update-missing-prices-v2?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMissingPricesV2(_response);
        });
    }

    protected processUpdateMissingPricesV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Recalculate AmRest WAC prices
     * @param storeNumber (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateAmrestWacMissingPrices(storeNumber?: string | undefined, body?: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stock/update-amrest-wac-missing-prices?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAmrestWacMissingPrices(_response);
        });
    }

    protected processUpdateAmrestWacMissingPrices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class StockCheckClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param storeNumber (optional) 
     * @param search (optional) 
     * @param date (optional) 
     * @param status (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    stockcheckGET(storeNumber?: string | undefined, search?: string | undefined, date?: string | undefined, status?: StockCheckStatus | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPagedData_1OfStockCheck> {
        let url_ = this.baseUrl + "/stockcheck?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockcheckGET(_response);
        });
    }

    protected processStockcheckGET(response: AxiosResponse): Promise<SuccessResponse_1OfPagedData_1OfStockCheck> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPagedData_1OfStockCheck>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPagedData_1OfStockCheck>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stockcheckPOST(body?: StockCheck | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockcheckPOST(_response);
        });
    }

    protected processStockcheckPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    stockcheckGET2(id: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStockCheckDetails> {
        let url_ = this.baseUrl + "/stockcheck/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockcheckGET2(_response);
        });
    }

    protected processStockcheckGET2(response: AxiosResponse): Promise<SuccessResponse_1OfStockCheckDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfStockCheckDetails>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfStockCheckDetails>(<any>null);
    }

    /**
     * @return Success
     */
    stockcheckDELETE(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockcheckDELETE(_response);
        });
    }

    protected processStockcheckDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param sortState (optional) 
     * @return Success
     */
    start(id: number, sortState?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/start?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sortState === null)
            throw new Error("The parameter 'sortState' cannot be null.");
        else if (sortState !== undefined)
            url_ += "sortState=" + encodeURIComponent("" + sortState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param countZoneId (optional) 
     * @param body (optional) 
     * @return Success
     */
    reorder(id: number, countZoneId?: number | undefined, body?: StockCheckItem[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/reorder?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (countZoneId === null)
            throw new Error("The parameter 'countZoneId' cannot be null.");
        else if (countZoneId !== undefined)
            url_ += "countZoneId=" + encodeURIComponent("" + countZoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReorder(_response);
        });
    }

    protected processReorder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(id: number, body?: StockCheckItem[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/submit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(id: number, body?: StockCheckItem[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/save";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savesingleitem(id: number, body?: StockCheckItem | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/savesingleitem";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavesingleitem(_response);
        });
    }

    protected processSavesingleitem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(id: number, body?: StockCheckItem[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/approve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getatlocation(id: number, locationId: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStockCheckDetails> {
        let url_ = this.baseUrl + "/stockcheck/{id}/getatlocation/{locationId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetatlocation(_response);
        });
    }

    protected processGetatlocation(response: AxiosResponse): Promise<SuccessResponse_1OfStockCheckDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfStockCheckDetails>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfStockCheckDetails>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitatlocation(id: number, locationId: number, body?: StockCheckItem[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/submitatlocation/{locationId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitatlocation(_response);
        });
    }

    protected processSubmitatlocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveatlocation(id: number, locationId: number, body?: StockCheckItem[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/saveatlocation/{locationId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveatlocation(_response);
        });
    }

    protected processSaveatlocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savesingleitematlocation(id: number, locationId: number, body?: StockCheckItem | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/savesingleitematlocation/{locationId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavesingleitematlocation(_response);
        });
    }

    protected processSavesingleitematlocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    hasoutstanding(storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/stockcheck/hasoutstanding?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasoutstanding(_response);
        });
    }

    protected processHasoutstanding(response: AxiosResponse): Promise<SuccessResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfBoolean>(<any>null);
    }

    /**
     * @return Success
     */
    rag2(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> {
        let url_ = this.baseUrl + "/stockcheck/rag";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRag2(_response);
        });
    }

    protected processRag2(response: AxiosResponse): Promise<SuccessResponse_1OfRAG> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfRAG>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfRAG>(<any>null);
    }

    /**
     * @return Success
     */
    g(red: boolean, amber: boolean, green: boolean , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfStockCheckRAG> {
        let url_ = this.baseUrl + "/stockcheck/getbyragstatus/r/{red}/a/{amber}/g/{green}";
        if (red === undefined || red === null)
            throw new Error("The parameter 'red' must be defined.");
        url_ = url_.replace("{red}", encodeURIComponent("" + red));
        if (amber === undefined || amber === null)
            throw new Error("The parameter 'amber' must be defined.");
        url_ = url_.replace("{amber}", encodeURIComponent("" + amber));
        if (green === undefined || green === null)
            throw new Error("The parameter 'green' must be defined.");
        url_ = url_.replace("{green}", encodeURIComponent("" + green));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processG(_response);
        });
    }

    protected processG(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfStockCheckRAG> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfStockCheckRAG>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfStockCheckRAG>(<any>null);
    }

    /**
     * @return Success
     */
    updateitems(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/{id}/updateitems";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateitems(_response);
        });
    }

    protected processUpdateitems(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    export4(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/stockcheck/{id}/export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport4(_response);
        });
    }

    protected processExport4(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @param body (optional) 
     * @return Success
     */
    bulkadd(id: number, storeNumber?: string | undefined, body?: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfBulkAddResponse> {
        let url_ = this.baseUrl + "/stockcheck/{id}/bulkadd?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkadd(_response);
        });
    }

    protected processBulkadd(response: AxiosResponse): Promise<SuccessResponse_1OfBulkAddResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfBulkAddResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfBulkAddResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    scan(id: string, body?: ScanStockCheckItemRequest | undefined , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/stockcheck/{id}/scan";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScan(_response);
        });
    }

    protected processScan(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(<any>null);
    }

    /**
     * @return Success
     */
    scanreport(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/stockcheck/{id}/scanreport";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScanreport(_response);
        });
    }

    protected processScanreport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class StockCheckScheduleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    stockcheckscheduleGET(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfStockCheckScheduleDetail> {
        let url_ = this.baseUrl + "/stockcheckschedule/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockcheckscheduleGET(_response);
        });
    }

    protected processStockcheckscheduleGET(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfStockCheckScheduleDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfStockCheckScheduleDetail>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfStockCheckScheduleDetail>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stockcheckschedulePOST(storeNumber: string, body?: StockCheckScheduleDetail | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheckschedule/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockcheckschedulePOST(_response);
        });
    }

    protected processStockcheckschedulePOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    scheduleGET(storeNumber: string, id: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStockCheckScheduleDetails> {
        let url_ = this.baseUrl + "/stockcheckschedule/{storeNumber}/schedule/{id}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScheduleGET(_response);
        });
    }

    protected processScheduleGET(response: AxiosResponse): Promise<SuccessResponse_1OfStockCheckScheduleDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfStockCheckScheduleDetails>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfStockCheckScheduleDetails>(<any>null);
    }

    /**
     * @return Success
     */
    scheduleDELETE(storeNumber: string, id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheckschedule/{storeNumber}/schedule/{id}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScheduleDELETE(_response);
        });
    }

    protected processScheduleDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    generatestockchecks(storeNumber: string, scheduleId: number , cancelToken?: CancelToken | undefined): Promise<GenerateStockCheckResponse> {
        let url_ = this.baseUrl + "/stockcheckschedule/{storeNumber}/generatestockchecks/{scheduleId}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeneratestockchecks(_response);
        });
    }

    protected processGeneratestockchecks(response: AxiosResponse): Promise<GenerateStockCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GenerateStockCheckResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateStockCheckResponse>(<any>null);
    }

    /**
     * @return Success
     */
    duplicate(storeNumber: string, id: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfInt32> {
        let url_ = this.baseUrl + "/stockcheckschedule/{storeNumber}/duplicate/{id}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicate(_response);
        });
    }

    protected processDuplicate(response: AxiosResponse): Promise<SuccessResponse_1OfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfInt32>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfInt32>(<any>null);
    }
}

export class StockCheckUomsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    uoms(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetStockCheckUomResponse> {
        let url_ = this.baseUrl + "/stockcheck/uoms/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUoms(_response);
        });
    }

    protected processUoms(response: AxiosResponse): Promise<SuccessResponse_1OfGetStockCheckUomResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetStockCheckUomResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetStockCheckUomResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body?: UpdateStockCheckUomsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stockcheck/uoms/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class StoresClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    storesGET(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStoreListResponse> {
        let url_ = this.baseUrl + "/stores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStoresGET(_response);
        });
    }

    protected processStoresGET(response: AxiosResponse): Promise<SuccessResponse_1OfStoreListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfStoreListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfStoreListResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    storesPOST(body?: PostStoresRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStoresPOST(_response);
        });
    }

    protected processStoresPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param franchiseName (optional) 
     * @return Success
     */
    franchisename(franchiseName?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStoreListResponse> {
        let url_ = this.baseUrl + "/stores/franchisename?";
        if (franchiseName === null)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFranchisename(_response);
        });
    }

    protected processFranchisename(response: AxiosResponse): Promise<SuccessResponse_1OfStoreListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfStoreListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfStoreListResponse>(<any>null);
    }

    /**
     * @param franchiseNames (optional) 
     * @return Success
     */
    franchiseinclude(franchiseNames?: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStoreListResponse> {
        let url_ = this.baseUrl + "/stores/franchiseinclude?";
        if (franchiseNames === null)
            throw new Error("The parameter 'franchiseNames' cannot be null.");
        else if (franchiseNames !== undefined)
            franchiseNames && franchiseNames.forEach(item => { url_ += "franchiseNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFranchiseinclude(_response);
        });
    }

    protected processFranchiseinclude(response: AxiosResponse): Promise<SuccessResponse_1OfStoreListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfStoreListResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfStoreListResponse>(<any>null);
    }

    /**
     * @return Success
     */
    refresh(cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stores/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enable(body?: PostStoreRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stores/enable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnable(_response);
        });
    }

    protected processEnable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    franchisenames(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStoreFranchiseNamesResponse> {
        let url_ = this.baseUrl + "/stores/franchisenames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFranchisenames(_response);
        });
    }

    protected processFranchisenames(response: AxiosResponse): Promise<SuccessResponse_1OfStoreFranchiseNamesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfStoreFranchiseNamesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfStoreFranchiseNamesResponse>(<any>null);
    }

    /**
     * @return Success
     */
    franchises(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfFranchise> {
        let url_ = this.baseUrl + "/stores/franchises";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFranchises(_response);
        });
    }

    protected processFranchises(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfFranchise> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfFranchise>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfFranchise>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    storenames(body?: UpdateStoreNamesRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stores/storenames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStorenames(_response);
        });
    }

    protected processStorenames(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    bidfoodWebshopCredentials(storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<BidfoodWebshopCredentials> {
        let url_ = this.baseUrl + "/stores/bidfood-webshop-credentials?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBidfoodWebshopCredentials(_response);
        });
    }

    protected processBidfoodWebshopCredentials(response: AxiosResponse): Promise<BidfoodWebshopCredentials> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BidfoodWebshopCredentials>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BidfoodWebshopCredentials>(<any>null);
    }
}

export class TasksClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param storeNumber (optional) 
     * @param taskType (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    tasks(storeNumber?: string | undefined, taskType?: string | undefined, skip?: number | undefined, take?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetTasksResponse> {
        let url_ = this.baseUrl + "/tasks?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (taskType === null)
            throw new Error("The parameter 'taskType' cannot be null.");
        else if (taskType !== undefined)
            url_ += "TaskType=" + encodeURIComponent("" + taskType) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTasks(_response);
        });
    }

    protected processTasks(response: AxiosResponse): Promise<SuccessResponse_1OfGetTasksResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetTasksResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetTasksResponse>(<any>null);
    }
}

export class TimezonesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    serverDatetime(timeZoneOffset?: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetServerDateTimeResponseDto> {
        let url_ = this.baseUrl + "/timezones/server-datetime?";
        if (timeZoneOffset === null)
            throw new Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServerDatetime(_response);
        });
    }

    protected processServerDatetime(response: AxiosResponse): Promise<GetServerDateTimeResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetServerDateTimeResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServerDateTimeResponseDto>(<any>null);
    }
}

export class TransactionReasonsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param actionType (optional) 
     * @param storeNumber (optional) 
     * @return Success
     */
    reasonsGET(actionType?: string | undefined, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetReasonsResponse> {
        let url_ = this.baseUrl + "/transactions/reasons?";
        if (actionType === null)
            throw new Error("The parameter 'actionType' cannot be null.");
        else if (actionType !== undefined)
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReasonsGET(_response);
        });
    }

    protected processReasonsGET(response: AxiosResponse): Promise<SuccessResponse_1OfGetReasonsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetReasonsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetReasonsResponse>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @param body (optional) 
     * @return Success
     */
    reasonsPOST(storeNumber?: string | undefined, body?: PostReasonRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transactions/reasons?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReasonsPOST(_response);
        });
    }

    protected processReasonsPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reasonsPUT(id: number, body?: PutReasonRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transactions/reasons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReasonsPUT(_response);
        });
    }

    protected processReasonsPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    reasonsDELETE(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transactions/reasons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReasonsDELETE(_response);
        });
    }

    protected processReasonsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TransactionsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param search (optional) 
     * @param direction (optional) 
     * @param type (optional) 
     * @param reason (optional) 
     * @param fieldToSort (optional) 
     * @param sortDirection (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param source (optional) 
     * @param sourceSearch (optional) 
     * @return Success
     */
    transactions(store: string, from: string, to: string, search?: string | undefined, direction?: string | undefined, type?: string | undefined, reason?: string | undefined, fieldToSort?: string | undefined, sortDirection?: string | undefined, skip?: number | undefined, take?: number | undefined, source?: string | undefined, sourceSearch?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPagedData_1OfProductTransactionSearch> {
        let url_ = this.baseUrl + "/transactions?";
        if (store === undefined || store === null)
            throw new Error("The parameter 'store' must be defined and cannot be null.");
        else
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "Reason=" + encodeURIComponent("" + reason) + "&";
        if (fieldToSort === null)
            throw new Error("The parameter 'fieldToSort' cannot be null.");
        else if (fieldToSort !== undefined)
            url_ += "FieldToSort=" + encodeURIComponent("" + fieldToSort) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (sourceSearch === null)
            throw new Error("The parameter 'sourceSearch' cannot be null.");
        else if (sourceSearch !== undefined)
            url_ += "SourceSearch=" + encodeURIComponent("" + sourceSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransactions(_response);
        });
    }

    protected processTransactions(response: AxiosResponse): Promise<SuccessResponse_1OfPagedData_1OfProductTransactionSearch> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPagedData_1OfProductTransactionSearch>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPagedData_1OfProductTransactionSearch>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createMany(body?: CreateMultipleTransactionsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transactions/createmany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMany(_response);
        });
    }

    protected processCreateMany(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pos(body?: CreateMultiplePosTransactionsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transactions/pos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPos(_response);
        });
    }

    protected processPos(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    rag3(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> {
        let url_ = this.baseUrl + "/transactions/rag";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRag3(_response);
        });
    }

    protected processRag3(response: AxiosResponse): Promise<SuccessResponse_1OfRAG> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfRAG>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfRAG>(<any>null);
    }

    /**
     * @return Success
     */
    getbyragstatus2(status: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfPosFeedLastReceived> {
        let url_ = this.baseUrl + "/transactions/getbyragstatus/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyragstatus2(_response);
        });
    }

    protected processGetbyragstatus2(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfPosFeedLastReceived> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfPosFeedLastReceived>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfPosFeedLastReceived>(<any>null);
    }

    /**
     * @return Success
     */
    clearcache(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transactions/clearcache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearcache(_response);
        });
    }

    protected processClearcache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearcache2(cache: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transactions/clearcache/{cache}";
        if (cache === undefined || cache === null)
            throw new Error("The parameter 'cache' must be defined.");
        url_ = url_.replace("{cache}", encodeURIComponent("" + cache));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearcache2(_response);
        });
    }

    protected processClearcache2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    voidproduct(body?: FactId | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transactions/voidproduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVoidproduct(_response);
        });
    }

    protected processVoidproduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    netsaleswidget(storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfNetSales> {
        let url_ = this.baseUrl + "/transactions/{storeNumber}/netsaleswidget";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNetsaleswidget(_response);
        });
    }

    protected processNetsaleswidget(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfNetSales> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfNetSales>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfNetSales>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getvoidedproducts(body?: FactId[] | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfVoidedTransaction> {
        let url_ = this.baseUrl + "/transactions/getvoidedproducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetvoidedproducts(_response);
        });
    }

    protected processGetvoidedproducts(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfVoidedTransaction> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfVoidedTransaction>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfVoidedTransaction>(<any>null);
    }
}

export class TransactionTypesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param enabled (optional) 
     * @return Success
     */
    typesGET(storeNumber: string, enabled?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse> {
        let url_ = this.baseUrl + "/transactions/types/{storeNumber}?";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        if (enabled === null)
            throw new Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTypesGET(_response);
        });
    }

    protected processTypesGET(response: AxiosResponse): Promise<SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    typesPATCH(id: number, body?: PatchTransactionTypeRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transactions/types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTypesPATCH(_response);
        });
    }

    protected processTypesPATCH(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TransfersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateitemquantity(body?: ValidateItemQuantityRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ValidateItemQuantityResponse> {
        let url_ = this.baseUrl + "/transfers/validateitemquantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateitemquantity(_response);
        });
    }

    protected processValidateitemquantity(response: AxiosResponse): Promise<ValidateItemQuantityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValidateItemQuantityResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateItemQuantityResponse>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @param transferNumber (optional) 
     * @param transferType (optional) 
     * @param date (optional) 
     * @param fieldToSort (optional) 
     * @param sortDirection (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param archived (optional) 
     * @return Success
     */
    transfersGET(storeNumber?: string | undefined, transferNumber?: number | undefined, transferType?: string | undefined, date?: string | undefined, fieldToSort?: string | undefined, sortDirection?: string | undefined, skip?: number | undefined, take?: number | undefined, archived?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetTransfersResponse> {
        let url_ = this.baseUrl + "/transfers?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (transferNumber === null)
            throw new Error("The parameter 'transferNumber' cannot be null.");
        else if (transferNumber !== undefined)
            url_ += "TransferNumber=" + encodeURIComponent("" + transferNumber) + "&";
        if (transferType === null)
            throw new Error("The parameter 'transferType' cannot be null.");
        else if (transferType !== undefined)
            url_ += "TransferType=" + encodeURIComponent("" + transferType) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (fieldToSort === null)
            throw new Error("The parameter 'fieldToSort' cannot be null.");
        else if (fieldToSort !== undefined)
            url_ += "FieldToSort=" + encodeURIComponent("" + fieldToSort) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (archived === null)
            throw new Error("The parameter 'archived' cannot be null.");
        else if (archived !== undefined)
            url_ += "Archived=" + encodeURIComponent("" + archived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransfersGET(_response);
        });
    }

    protected processTransfersGET(response: AxiosResponse): Promise<SuccessResponse_1OfGetTransfersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetTransfersResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetTransfersResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transfersPOST(body?: CreateTransferRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transfers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransfersPOST(_response);
        });
    }

    protected processTransfersPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param userStore (optional) 
     * @return Success
     */
    transfersGET2(id: number, userStore?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfTransferHeader> {
        let url_ = this.baseUrl + "/transfers/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userStore === null)
            throw new Error("The parameter 'userStore' cannot be null.");
        else if (userStore !== undefined)
            url_ += "userStore=" + encodeURIComponent("" + userStore) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransfersGET2(_response);
        });
    }

    protected processTransfersGET2(response: AxiosResponse): Promise<SuccessResponse_1OfTransferHeader> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfTransferHeader>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfTransferHeader>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    transfersPATCH(id: number, body?: ReceiveTransferHeaderRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transfers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransfersPATCH(_response);
        });
    }

    protected processTransfersPATCH(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    transfersDELETE(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transfers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransfersDELETE(_response);
        });
    }

    protected processTransfersDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TransportCostsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transportcostsPOST(body?: TransportCost | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transportcosts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransportcostsPOST(_response);
        });
    }

    protected processTransportcostsPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    transportcostsGET(storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfTransportCost> {
        let url_ = this.baseUrl + "/transportcosts?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransportcostsGET(_response);
        });
    }

    protected processTransportcostsGET(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfTransportCost> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfTransportCost>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfTransportCost>(<any>null);
    }

    /**
     * @return Success
     */
    transportcostsGET2(id: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfTransportCost> {
        let url_ = this.baseUrl + "/transportcosts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransportcostsGET2(_response);
        });
    }

    protected processTransportcostsGET2(response: AxiosResponse): Promise<SuccessResponse_1OfTransportCost> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfTransportCost>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfTransportCost>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transportcostsPUT(id: number, body?: TransportCost | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/transportcosts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransportcostsPUT(_response);
        });
    }

    protected processTransportcostsPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class UsersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    usersPOST(body?: CreateUserRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersPOST(_response);
        });
    }

    protected processUsersPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    usersGET(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfUserListResponse> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersGET(_response);
        });
    }

    protected processUsersGET(response: AxiosResponse): Promise<SuccessResponse_1OfUserListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfUserListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfUserListResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body?: ActivateUserRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    usersPUT(id: number, body?: PutUserRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersPUT(_response);
        });
    }

    protected processUsersPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    usersDELETE(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersDELETE(_response);
        });
    }

    protected processUsersDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    usersGET2(id: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfUser> {
        let url_ = this.baseUrl + "/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersGET2(_response);
        });
    }

    protected processUsersGET2(response: AxiosResponse): Promise<SuccessResponse_1OfUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfUser>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfUser>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    resetpassword(body?: ResetPasswordRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/resetpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetpassword(_response);
        });
    }

    protected processResetpassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import3(body?: ImportUserRequest[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport3(_response);
        });
    }

    protected processImport3(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkusersactions(body?: BulkUserActionRequest[] | undefined , cancelToken?: CancelToken | undefined): Promise<BulkUserActionResponse[]> {
        let url_ = this.baseUrl + "/users/bulkusersactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkusersactions(_response);
        });
    }

    protected processBulkusersactions(response: AxiosResponse): Promise<BulkUserActionResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BulkUserActionResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkUserActionResponse[]>(<any>null);
    }

    /**
     * @param franchiseName (optional) 
     * @return Success
     */
    franchisename2(franchiseName?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfUserListResponse> {
        let url_ = this.baseUrl + "/users/franchisename?";
        if (franchiseName === null)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFranchisename2(_response);
        });
    }

    protected processFranchisename2(response: AxiosResponse): Promise<SuccessResponse_1OfUserListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfUserListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfUserListResponse>(<any>null);
    }

    /**
     * @return Success
     */
    currentuser(  cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfUser> {
        let url_ = this.baseUrl + "/users/currentuser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrentuser(_response);
        });
    }

    protected processCurrentuser(response: AxiosResponse): Promise<SuccessResponse_1OfUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfUser>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfUser>(<any>null);
    }

    /**
     * @return Success
     */
    getStoreUsersWithRole(role: Roles, storeNumber: string , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfUser> {
        let url_ = this.baseUrl + "/users/role/{role}/store/{storeNumber}";
        if (role === undefined || role === null)
            throw new Error("The parameter 'role' must be defined.");
        url_ = url_.replace("{role}", encodeURIComponent("" + role));
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStoreUsersWithRole(_response);
        });
    }

    protected processGetStoreUsersWithRole(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfUser>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfUser>(<any>null);
    }

    /**
     * @param franchiseName (optional) 
     * @return Success
     */
    exporttemplate(franchiseName?: string | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/users/exporttemplate?";
        if (franchiseName === null)
            throw new Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExporttemplate(_response);
        });
    }

    protected processExporttemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param userEmail (optional) 
     * @param storeNumber (optional) 
     * @return Success
     */
    checkStoreAccess(userEmail?: string | undefined, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/check-store-access?";
        if (userEmail === null)
            throw new Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckStoreAccess(_response);
        });
    }

    protected processCheckStoreAccess(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class WasteClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    wasteGET(id: number , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfWasteCheckSheetResponse> {
        let url_ = this.baseUrl + "/waste/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWasteGET(_response);
        });
    }

    protected processWasteGET(response: AxiosResponse): Promise<SuccessResponse_1OfWasteCheckSheetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfWasteCheckSheetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfWasteCheckSheetResponse>(<any>null);
    }

    /**
     * @return Success
     */
    wasteDELETE(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/waste/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWasteDELETE(_response);
        });
    }

    protected processWasteDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create2(body?: WasteCheckSheetRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfInt32> {
        let url_ = this.baseUrl + "/waste/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate2(_response);
        });
    }

    protected processCreate2(response: AxiosResponse): Promise<SuccessResponse_1OfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfInt32>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    submit2(body?: WasteCheckSheetRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/waste/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit2(_response);
        });
    }

    protected processSubmit2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @param date (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param type (optional) 
     * @param fieldToSort (optional) 
     * @param sortDirection (optional) 
     * @return Success
     */
    wasteGET2(storeNumber?: string | undefined, date?: string | undefined, skip?: number | undefined, take?: number | undefined, type?: number | undefined, fieldToSort?: string | undefined, sortDirection?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPagedData_1OfWasteHeaders> {
        let url_ = this.baseUrl + "/waste?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (fieldToSort === null)
            throw new Error("The parameter 'fieldToSort' cannot be null.");
        else if (fieldToSort !== undefined)
            url_ += "FieldToSort=" + encodeURIComponent("" + fieldToSort) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWasteGET2(_response);
        });
    }

    protected processWasteGET2(response: AxiosResponse): Promise<SuccessResponse_1OfPagedData_1OfWasteHeaders> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfPagedData_1OfWasteHeaders>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfPagedData_1OfWasteHeaders>(<any>null);
    }
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export interface UpdateConfigurationRequest {
    value?: string | undefined;
}

export interface CreateInvoiceItemRequest {
    lineNumber?: number;
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    itemCategory?: string | undefined;
    uom?: string | undefined;
    quantity?: number;
    pricePerUnit?: number;
    goodsValue?: number;
    vatCode?: string | undefined;
    vatValue?: number;
    lineValue?: number;
    status?: string | undefined;
    creditRequested?: boolean;
}

export interface CreateInvoiceRequest {
    storeNumber?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceType?: InvoiceType;
    orderNumber?: string | undefined;
    ewsOrderNumber?: string | undefined;
    customisedOrderNumber?: string | undefined;
    originalInvoiceNumber?: string | undefined;
    invoiceDate?: string;
    deliveryDate?: string;
    billingName?: string | undefined;
    billingAccount?: string | undefined;
    invoiceValue?: number;
    invoiceItems?: CreateInvoiceItemRequest[] | undefined;
}

export interface UpdateInvoiceRequest {
    accepted?: boolean;
    note?: string | undefined;
}

export interface UpsertItem {
    id?: number;
    itemNumber?: string | undefined;
    storeNumber?: string | undefined;
    description?: string | undefined;
    primaryCategory?: string | undefined;
    familyGroupName?: string | undefined;
    status?: string | undefined;
    uom?: string | undefined;
    weightNet?: number;
    isBom?: boolean;
    isPosEnabled?: boolean;
    isSaleItem?: boolean;
    isStockItem?: boolean;
    itemVolume?: number | undefined;
}

export interface UpsertItemComponent {
    itemId?: number;
    componentItemId?: number;
    quantity?: number;
    weight?: number;
    volume?: number | undefined;
}

export interface DeleteStockCheckDoNotCountItemRequest {
    franchiseId?: number;
    itemNumber?: string | undefined;
}

export interface GetItemsByIdsRequest {
    storeNumber?: string | undefined;
    itemNumbers?: string[] | undefined;
    stockItemsOnly?: boolean;
}

export interface GetItemsByStoresRequest {
    stores?: string[] | undefined;
}

export interface GetRecipeChangesByIDRequest {
    changeIDs?: number[] | undefined;
}

export interface ItemStockOnHandRequest {
    storeNumber?: string | undefined;
    itemNumbers?: string[] | undefined;
}

export interface PostStockCheckDoNotCountItemRequest {
    franchiseId?: number;
    itemNumber?: string[] | undefined;
}

export interface RefreshItemsRequest {
    storeNumber?: string | undefined;
    items?: ItemRecipe2[] | undefined;
}

export interface SearchItemsByStoresRequest {
    stores?: string[] | undefined;
    search?: string | undefined;
}

export interface LocationRequest {
    id?: number;
    name: string;
    storeNumber: string;
}

export interface ItemComponent {
    itemId?: number;
    componentId?: number;
    componentItemNumber?: string | undefined;
    componentDescription?: string | undefined;
    uom?: string | undefined;
    quantity?: number;
    weight?: number;
    volume?: number | undefined;
    storeNumber?: string | undefined;
    storeName?: string | undefined;
    isCreated?: boolean;
}

export interface MadeInStoreItemRequest {
    id: number;
    store: string;
    itemNumber: string;
    description?: string | undefined;
    primaryUOM?: string | undefined;
    stockOnHandQuantity: number;
    maximumQuantity: number;
    quantity: number;
    madeInStoreComponents?: MadeInStoreComponent[] | undefined;
}

export interface Notification {
    notificationId?: number;
    active?: boolean;
    notificationType?: NotificationType;
    startDate?: string;
    endDate?: string;
    title?: string | undefined;
    message?: string | undefined;
    createdBy?: number;
    storeIds?: string[] | undefined;
    franchiseIds?: number[] | undefined;
}

export interface DeletePosMappingRequest {
    source?: string | undefined;
    target?: string | undefined;
    mappingType?: number;
}

export interface DeletePaperPackagingRequest {
    itemNumber?: string | undefined;
    cupsLidsType?: number;
    paperPackagingType?: number;
}

export interface GetPaperPackagingResponse {
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    cupsLidsType?: number;
    paperPackagingType?: number;
    sizes?: number[] | undefined;
    franchiseNames?: string[] | undefined;
    stores?: UpdateStoreName[] | undefined;
}

export interface PostPaperPackagingRequest {
    itemNumber?: string | undefined;
    cupsLidsType?: number;
    paperPackagingType?: number;
    sizes?: number[] | undefined;
    allStores?: boolean;
    storeNumbers?: string[] | undefined;
    franchiseIds?: number[] | undefined;
}

export interface PutPaperPackagingRequest {
    itemNumber?: string | undefined;
    cupsLidsType?: number;
    paperPackagingType?: number;
    sizes?: number[] | undefined;
    allStores?: boolean;
    storeNumbers?: string[] | undefined;
    franchiseIds?: number[] | undefined;
    oldCupsLidsType?: number;
    oldPaperPackagingType?: number;
}

export interface PostPersonaRequest {
    description?: string | undefined;
    franchiseName?: string | undefined;
    personaRoles?: string[] | undefined;
}

export interface PutPersonaRequest {
    description?: string | undefined;
    franchiseName?: string | undefined;
    personaRoles?: string[] | undefined;
}

export interface PostPosMappingRequest {
    source: string;
    target: string;
    mappingType: number;
    franchiseId?: number;
    allStores: boolean;
    storeNumbers?: string[] | undefined;
    franchiseIds?: number[] | undefined;
}

export interface PutPosMappingRequest {
    newSource: string;
    source: string;
    target: string;
    mappingType: number;
    allStores: boolean;
    storeNumbers?: string[] | undefined;
    franchiseIds?: number[] | undefined;
}

export interface ItemPrimaryCategoryOverride {
    primaryCategoryId?: number;
    itemNumber?: string | undefined;
}

export interface PrimaryCategory {
    id?: number;
    franchiseId?: number;
    primaryCategoryName?: string | undefined;
    systemGenerated?: boolean;
    smartCount?: boolean;
    zeroStockItem?: boolean;
    includeInReports?: boolean;
    salesForecast?: boolean;
    wasteCheckSheet?: boolean;
    itemPrimaryCategoryOverrides?: ItemPrimaryCategoryOverride[] | undefined;
}

export interface AddItemsInPurchaseOrderRequest {
    purchaseOrderHeaderId: number;
    storeNumber: string;
    items?: AddItemsInPurchaseOrderRequest_CreatePurchaseOrderItem[] | undefined;
}

export interface AddItemsInPurchaseOrderRequest_CreatePurchaseOrderItem {
    itemNumber: string;
    description: string;
    uom: string;
    requestedQuantity: number;
    costPrice: number;
}

export interface BeginCreditReqRequest {
    ewsOrderNumber: string;
    storeNumber?: string | undefined;
    items: BeginCreditReqRequest_LineItems[];
}

export interface BeginCreditReqRequest_LineItems {
    itemNumber: string;
    receivedQuantity: number;
    receivedUOM: string;
}

export interface CalculateDiscrepanciesLine {
    itemNumber?: string | undefined;
    expectedQuantity?: number;
    expectedUOM?: string | undefined;
    receivedQuantity?: number;
    receivedUOM?: string | undefined;
}

export interface CreatePurchaseOrderHeaderRequest {
    orderNumber?: string | undefined;
    ewsOrderNumber?: string | undefined;
    customisedOrderNumber?: string | undefined;
    storeNumber?: string | undefined;
    orderType?: string | undefined;
    orderTypeID?: number;
    deliveryDate?: string;
    invoiceNumber?: string | undefined;
    note?: string | undefined;
    creditRequestStatus?: number;
    creditRequestSentDateTime?: string | undefined;
    creditRequestReceivedDateTime?: string | undefined;
    bpaNumber?: string | undefined;
    supplierName?: string | undefined;
    supplierSiteCode?: string | undefined;
    supplierEmail?: string | undefined;
    supplierEmail2?: string | undefined;
    poOrderRequestDateTime?: string | undefined;
    vendorAccountNumber?: string | undefined;
    erpOrderId?: string | undefined;
    fromLocationID?: string | undefined;
    toLocationID?: string | undefined;
    erpOrderNumber?: string | undefined;
    erpRequisitionNumber?: string | undefined;
    purchaseOrderLines?: CreatePurchaseOrderLineRequest[] | undefined;
}

export interface CreatePurchaseOrderLineRequest {
    lineNumber?: string | undefined;
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    expectedUom?: string | undefined;
    expectedQuantity?: number;
    unitCostPrice?: number;
    bpaLineNumber?: number | undefined;
    vendorItemNumber?: string | undefined;
    erpInternalID?: string | undefined;
}

export interface PostReturnablePackagingItemRequest {
    returnablePackagingItemID?: string | undefined;
    webOrderID?: string | undefined;
    productID?: string | undefined;
    quantity?: string | undefined;
    unitPrice?: string | undefined;
    deliveryNoteNumber?: string | undefined;
    supplier?: string | undefined;
    deliveryDate?: string | undefined;
    storeNumber?: string | undefined;
    orderableUOM?: string | undefined;
}

export interface PostReturnablePackagingItemsRequest {
    items?: PostReturnablePackagingItemRequest[] | undefined;
}

export interface PutPurchaseOrderHeaderRequest {
    packingSlipNumber?: string | undefined;
    storeNumber?: string | undefined;
    acceptedDate?: string | undefined;
    note?: string | undefined;
    isReceived?: boolean;
    receivedType?: ReceivedType;
    putPurchaseOrderLineRequests: PutPurchaseOrderLineRequest[];
    orderReference?: string | undefined;
}

export interface PutPurchaseOrderLineRequest {
    id: number;
    itemNumber?: string | undefined;
    receivedUom?: string | undefined;
    receivedQuantity?: number;
    expectedUom?: string | undefined;
    expectedQuantity?: number;
    note?: string | undefined;
    isSelected: boolean;
    creditedAmount?: number;
    reason?: string | undefined;
}

export interface ReturnToVendorRequest {
    purchaseOrderHeaderId: string;
    storeNumber: string;
    customerRmaNumber: string;
    items: ReturnToVendorRequest_LineItems[];
}

export interface ReturnToVendorRequest_LineItems {
    itemNumber: string;
    returnToVendorQuantity: number;
    returnToVendorUom: string;
}

export interface SendCreditReqRequest {
    purchaseOrderHeaderId?: number;
    ewsOrderNumber: string;
    storeNumber?: string | undefined;
    customerRmaNumber?: string | undefined;
    deliveryNoteNumber?: string | undefined;
    documents?: string | undefined;
    items: SendCreditReqRequest_LineItems[];
}

export interface SendCreditReqRequest_LineItemFile {
    fileName: string;
    fileData: string;
}

export interface SendCreditReqRequest_LineItems {
    itemNumber: string;
    reasonForCreditRequest: number;
    photos?: SendCreditReqRequest_LineItemFile[] | undefined;
}

export interface PostReasonRequest {
    id?: number;
    name: string;
    description?: string | undefined;
    actionType?: string | undefined;
    franchiseId?: number;
    active?: boolean;
}

export interface PutReasonRequest {
    description?: string | undefined;
    actionType?: string | undefined;
}

export interface GenerateReportRequest {
    reportId?: number | undefined;
    from?: string;
    to?: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores?: boolean;
    report?: ReportDto;
}

export interface AIPerformanceReportRequest {
    storeNumbers?: string[] | undefined;
    startDate?: string;
    endDate?: string;
}

export interface CheckReportRequest {
    from: string;
    to: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface ConstrainedItemReportRequest {
    from: string;
    to: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface CostOfSalesRequest {
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface CreditPurchaseReportRequest {
    from: string;
    to: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface DcShortageReportRequest {
    date: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores?: boolean;
}

export interface ExtendedStockCountReportRequest {
    date: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface InvoiceReconciliationRequest {
    from?: string;
    to?: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface ItemActivityReportRequest {
    from: string;
    to: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface ItemStockOutRequest {
    from?: string;
    to?: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface ItemTimeOutRequest {
    from?: string;
    to?: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface ItemUsageReportRequest {
    from: string;
    to: string;
    stores: string[];
    primaryCategoryIds: number[];
    reportOnAllAvailableStores: boolean;
}

export interface MadeInStoreReportRequest {
    from: string;
    to: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface PostSupplierRequest {
    supplierNumber?: string | undefined;
    supplierName?: string | undefined;
    market?: string | undefined;
}

export interface PostSuppliersRequest {
    suppliers?: PostSupplierRequest[] | undefined;
}

export interface ProductMarginReportRequest {
    from: string;
    to: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface ReceiptsReportRequest {
    from: string;
    to: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface RequestCOGsReportRequest {
    from?: string;
    to?: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface RequestItemHistoryReportRequest {
    itemId?: string | undefined;
    storeNumber?: string | undefined;
    from?: string;
    to?: string;
}

export interface RequestStockCountsVsUsageReportRequest {
    from?: string;
    to?: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores: boolean;
    districts?: number[] | undefined;
}

export interface RequestSystemAuditingReportRequest {
    from: string;
    to: string;
    store?: string | undefined;
    franchise: number;
    systemAreaId: AuditLogSystemArea;
}

export interface RequestTheoryActualReportRequest {
    from?: string;
    to?: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
    districts?: number[] | undefined;
    isAmrestReport?: boolean;
}

export interface ReturnablePackagingReportRequest {
    from: string;
    to: string;
    stores: string[];
    reportOnAllAvailableStores: boolean;
}

export interface StockCountSummaryReportRequest {
    date: string;
    stores?: string[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface StockOnHandReportRequest {
    date: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    itemNumbers?: string[] | undefined;
    reportOnAllAvailableStores: boolean;
    hasRecentActivity?: boolean;
    onlyMadeInStore?: boolean;
}

export interface TransfersReportRequest {
    from: string;
    to: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface UploadDoNotCountItemsRequest {
    name?: string | undefined;
    content?: string | undefined;
}

export interface WasteReportRequest {
    from: string;
    to: string;
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface PutStockRequest {
    itemNumber?: string | undefined;
    storeNumber?: string | undefined;
    minimumQuantity?: number;
}

export interface ScanStockCheckItemRequest {
    stockCheckId?: number;
    stockCheckItemId?: number | undefined;
    barcode?: string | undefined;
}

export interface UpdateStockCheckUomsRequest {
    stockCheckUoms?: StockCheckUom[] | undefined;
}

export interface StockDaysRequest {
    stores?: string[] | undefined;
    primaryCategoryIds?: number[] | undefined;
    reportOnAllAvailableStores: boolean;
}

export interface DeliverySchedule {
    storeNumber?: string | undefined;
    orderType?: number;
    cutOffDate?: string;
    deliveryDate?: string;
    supplierNumber?: string | undefined;
}

export interface PostStoreRequest {
    storeNumber?: string | undefined;
    starbucksStoreNumber?: string | undefined;
    storeName?: string | undefined;
    storeGroup?: string | undefined;
    legalEntity?: string | undefined;
    franchiseName?: string | undefined;
    country?: string | undefined;
    town?: string | undefined;
    storeNumberForRecipes?: string | undefined;
    creditRequestsEnabled?: boolean;
    creditRequestsRequirePhotographicEvidence?: boolean;
    erpLocationID?: string | undefined;
    deliverySchedules?: DeliverySchedule[] | undefined;
    storeAttributes?: KeyValuePair_2OfStringAndString[] | undefined;
}

export interface PostStoresRequest {
    stores?: PostStoreRequest[] | undefined;
}

export interface UpdateStoreNameRequest {
    storeNumber?: string | undefined;
    storeName?: string | undefined;
}

export interface UpdateStoreNamesRequest {
    stores?: UpdateStoreNameRequest[] | undefined;
}

export interface CreateMultiplePosTransactionsRequest {
    transactions?: CreatePosTransactionsRequest[] | undefined;
    store?: string | undefined;
    transactionDate?: string;
    createAll?: boolean;
}

export interface CreateMultipleTransactionsRequest {
    transactions?: CreateTransactionRequest[] | undefined;
    store?: string | undefined;
}

export interface CreatePosTransactionsRequest {
    sourceTransactionId?: string | undefined;
    transactions?: CreateTransactionRequest[] | undefined;
    sourceTransactionData?: CreateSourceTransactionDataRequest[] | undefined;
    unmappedItems?: UnmappedItems[] | undefined;
}

export interface CreateSourceTransactionDataRequest {
    store: string;
    sourceTransactionID: string;
    sourceTransactionDate: string;
    type: string;
    filename: string;
    dataLine: string;
    errorCode?: number | undefined;
}

export interface CreateTransactionModifier {
    name?: string | undefined;
    familyGroupName?: string | undefined;
    recordNumber?: number;
    itemNumber?: string | undefined;
    quantity?: number;
    uom?: string | undefined;
    note?: string | undefined;
    date?: string | undefined;
    salePriceNet?: number | undefined;
    salePriceGross?: number | undefined;
}

export interface CreateTransactionRequest {
    store: string;
    itemNumber: string;
    description?: string | undefined;
    type: string;
    direction: string;
    quantity: number;
    uom: string;
    note?: string | undefined;
    costPrice?: number | undefined;
    reason?: string | undefined;
    date?: string | undefined;
    timezoneOffset?: number | undefined;
    source?: string | undefined;
    sourceTransactionID?: string | undefined;
    orderType?: number | undefined;
    totalSalePriceNet?: number | undefined;
    totalSalePriceGross?: number | undefined;
    totalDiscountGross?: number | undefined;
    totalDiscountNet?: number | undefined;
    discountReason?: string | undefined;
    createdBy?: string | undefined;
    transactionModifiers?: CreateTransactionModifier[] | undefined;
}

export interface UnmappedItems {
    menuId?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
}

export interface CreateTransferRequest {
    transferDate?: string | undefined;
    transferType: string;
    storeNumber: string;
    otherStoreNumber: string;
    note?: string | undefined;
    items?: CreateTransferRequest_CreateTransferRequestItem[] | undefined;
}

export interface CreateTransferRequest_CreateTransferRequestItem {
    itemNumber: string;
    uom: string;
    requestedQuantity: number;
}

export interface ReceiveTransferDetailRequest {
    id: number;
    receivedQuantity: number;
    receivedUom: string;
}

export interface ReceiveTransferHeaderRequest {
    receiveTransferDetailRequests: ReceiveTransferDetailRequest[];
}

export interface ValidateItemQuantityRequest {
    storeNumber: string;
    itemNumber: string;
    quantity: number;
    uom: string;
}

export interface BulkUserActionRequest {
    id?: number | undefined;
    email?: string | undefined;
    franchiseName?: string | undefined;
    personaId?: number;
    stores?: string[] | undefined;
    allStores?: boolean;
    passwordReset?: boolean;
    deleteUser?: boolean;
}

export interface ImportUserRequest {
    emailAddress?: string | undefined;
    persona?: string | undefined;
    franchiseName?: string | undefined;
    authorization?: boolean;
    storeNumbers?: string[] | undefined;
    allStores?: boolean;
}

export interface PutUserRequest {
    emailAddress?: string | undefined;
    stores?: string[] | undefined;
    franchiseIds?: number[] | undefined;
    personaId?: number | undefined;
    districtId?: number | undefined;
    allStores?: boolean;
    franchiseName?: string | undefined;
}

export interface ItemRequest {
    id: number;
    uom: string;
    itemNumber: string;
    description?: string | undefined;
    pastDueQty?: number | undefined;
    sampledQty?: number | undefined;
    damagedQty?: number | undefined;
    storeUseQty?: number | undefined;
}

export interface WasteCheckSheetRequest {
    id: number;
    storeNumber: string;
    createdDate?: string | undefined;
    submittedDate?: string | undefined;
    submittedBy?: string | undefined;
    items?: ItemRequest[] | undefined;
}

export interface AutomatedTaskDetails {
    automatedTask?: AutomatedTask;
    franchiseNames?: string[] | undefined;
}

export interface Configuration {
    id?: number;
    name?: string | undefined;
    franchiseName?: string | undefined;
    storeNumber?: string | undefined;
    level?: KeyValuePair_2OfStringAndString;
    valueType?: string | undefined;
    value?: string | undefined;
}

export interface GetConfigurationResponse {
    configurations?: Configuration[] | undefined;
}

export interface District {
    id?: number;
    description?: string | undefined;
    franchiseName?: string | undefined;
    districtStores?: KeyValuePair_2OfStringAndString[] | undefined;
}

export interface DistrictSummary {
    id?: number;
    description?: string | undefined;
}

export interface Franchise {
    franchiseId?: number;
    franchiseName?: string | undefined;
    active?: boolean;
}

export interface GetInvoicesResponse {
    invoiceCount?: number;
    invoices?: Invoice[] | undefined;
}

export interface Invoice {
    id?: number;
    storeNumber?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceType?: string | undefined;
    invoiceDate?: string;
    deliveryDate?: string;
    orderNumber?: string | undefined;
    ewsOrderNumber?: string | undefined;
    customisedOrderNumber?: string | undefined;
    purchaseOrderHeaderId?: number;
    originalInvoiceNumber?: string | undefined;
    billingName?: string | undefined;
    billingAccount?: string | undefined;
    invoiceValue?: number;
    receivedValue?: number | undefined;
    creditValue?: number | undefined;
    discrepancyValue?: number | undefined;
    vatValue?: number | undefined;
    invoiceTotal?: number | undefined;
    status?: string | undefined;
    note?: string | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
}

export interface InvoiceItem {
    id?: number;
    invoiceId?: number;
    lineNumber?: number;
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    itemCategory?: string | undefined;
    uom?: string | undefined;
    quantity?: number;
    pricePerUnit?: number;
    goodsValue?: number;
    vatCode?: string | undefined;
    vatValue?: number;
    lineValue?: number;
    receivedQuantity?: number;
    receivedPricePerUnit?: number;
    receivedGoodsValue?: number;
    creditRequested?: boolean;
    creditQuantity?: number;
    creditPricePerUnit?: number;
    creditGoodsValue?: number;
    creditNoteId?: number | undefined;
    status?: string | undefined;
    note?: string | undefined;
}

export interface InvoiceRag {
    invoiceDate?: string;
    storeName?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceValue?: number;
}

export interface ItemDailyHistory {
    date?: string;
    dayPrice?: number | undefined;
    opening?: number | undefined;
    receipts?: number | undefined;
    madeInStore?: number | undefined;
    transferIn?: number | undefined;
    transferOut?: number | undefined;
    sales?: number | undefined;
    waste?: number | undefined;
    returnToStock?: number | undefined;
    theoUsage?: number | undefined;
    theoClosing?: number | undefined;
    inventory?: number | undefined;
    closingVar?: number | undefined;
    returnToVendor?: number | undefined;
    transportCost?: number | undefined;
}

export interface CostHistory {
    date?: string;
    totalCostPrice?: number;
    unitCostPrice?: number;
    quantity?: number;
    uom?: string | undefined;
    reason?: string | undefined;
}

export interface GetItemsResponse {
    itemCount?: number;
    items?: Item[] | undefined;
}

export interface Item {
    id?: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    uom?: string | undefined;
    status?: string | undefined;
    primaryCategory?: string | undefined;
    familyGroupName?: string | undefined;
    pickPackUom?: string | undefined;
    costPrice?: number;
    imageUrl?: string | undefined;
    imageUrlLarge?: string | undefined;
    weightNet?: number;
    isBom?: boolean;
    isStockItem?: boolean;
    isSaleItem?: boolean;
    isPosEnabled?: boolean;
    itemVolume?: number | undefined;
    isMadeInStore?: boolean;
    storeNumber?: string | undefined;
    sku?: string | undefined;
    isDepositItem?: boolean;
    isDepositFeeItem?: boolean;
    depositFeeItemNumber?: string | undefined;
    isAllowPartialUomTransactions?: boolean;
    isNew?: boolean;
    doNotCountCreatedDate?: string | undefined;
}

export interface ItemStockOnHandResponse {
    itemNumber?: string | undefined;
    stockOnHand?: number;
    uom?: string | undefined;
    isSaleItem?: boolean;
    lastSale?: string | undefined;
    useLastSaleTime?: boolean;
}

export interface Recipe {
    id?: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    costPriceOnHand?: number | undefined;
    status?: string | undefined;
    primaryCategory?: string | undefined;
    recipeComponents?: RecipeComponent[] | undefined;
}

export interface RecipeComponent {
    quantity?: number;
    weight?: number;
    uom?: string | undefined;
    volume?: number | undefined;
    componentId?: number;
    componentItemNumber?: string | undefined;
    componentDescription?: string | undefined;
    componentWeightNet?: number;
    componentCostPriceOnHand?: number | undefined;
    componentVolume?: number | undefined;
}

export interface GenericLocationResponse {
    message?: string | undefined;
    success?: boolean;
}

export interface LocationResponse {
    id?: number;
    name?: string | undefined;
    storeNumber?: string | undefined;
}

export interface PostLocationResponse {
    id?: number;
    name?: string | undefined;
    storeNumber?: string | undefined;
    message?: string | undefined;
    isSuccess?: boolean;
}

export interface StoreItem {
    itemNumber?: string | undefined;
    storeNumber?: string | undefined;
    starbucksStoreNumber?: string | undefined;
}

export interface Material {
    itemNumber?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    uom?: string | undefined;
    imageUrl?: string | undefined;
    imageUrlLarge?: string | undefined;
    packSize?: string | undefined;
    pickPackUom?: string | undefined;
    weightUom?: string | undefined;
    weightGross?: number;
    weightNet?: number;
    costPrice?: number;
    status?: string | undefined;
    isBom?: boolean;
    isStockItem?: boolean;
    isSaleItem?: boolean;
    isPosEnabled?: boolean;
}

export interface Notification2 {
    notificationId?: number;
    active?: boolean;
    notificationType?: NotificationType;
    startDate?: string;
    endDate?: string;
    title?: string | undefined;
    message?: string | undefined;
    createdBy?: number;
    storeIds?: string[] | undefined;
    franchiseIds?: number[] | undefined;
}

export interface PagedData_1OfGetPaperPackagingResponse {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: GetPaperPackagingResponse[] | undefined;
}

export interface PagedData_1OfRecipe {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: Recipe[] | undefined;
}

export interface PagedData_1OfGetPosMappingResponse {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: GetPosMappingResponse[] | undefined;
}

export interface PagedData_1OfProductTransactionSearch {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: ProductTransactionSearch[] | undefined;
}

export interface PagedData_1OfGroupedItemFeedChange {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: GroupedItemFeedChange[] | undefined;
}

export interface PagedData_1OfItemFeedChange {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: ItemFeedChange[] | undefined;
}

export interface PagedData_1OfMadeInStoreItem {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: MadeInStoreItem[] | undefined;
}

export interface Persona {
    id?: number;
    description?: string | undefined;
    franchiseName?: string | undefined;
    personaRoles?: string[] | undefined;
    users?: UserSmall[] | undefined;
}

export interface GetPosMappingResponse {
    mappingType?: number;
    mappingTypeDesc?: string | undefined;
    source?: string | undefined;
    target?: string | undefined;
    itemDesc?: string | undefined;
    franchiseNames?: string[] | undefined;
    stores?: UpdateStoreName[] | undefined;
}

export interface PredictiveOrderingDate {
    date?: string;
    deliveryTypes?: PredictiveOrderingDeliveryType[] | undefined;
    expectedSalesValue?: number;
    salesValueAWeekAgo?: number | undefined;
    salesValueAverage?: number | undefined;
    warnings?: string[] | undefined;
    totalStockOnHandValue?: number | undefined;
}

export interface PredictiveOrderingDeliveryType {
    orderType?: number;
    selected?: boolean;
    totalDeliveryValue?: number | undefined;
}

export interface PredictiveOrderingDetails {
    id?: string | undefined;
    storeNumber?: string | undefined;
    startDate?: string;
    endDate?: string;
    dailyAverageSalesValue?: number;
    dateDetails?: PredictiveOrderingDate[] | undefined;
}

export interface BulkAddResponse {
    success?: string[] | undefined;
    fails?: string[] | undefined;
}

export interface ItemPrimaryCategoryOverride2 {
    primaryCategoryId?: number;
    itemNumber?: string | undefined;
}

export interface PrimaryCategory2 {
    id?: number;
    franchiseId?: number;
    primaryCategoryName?: string | undefined;
    systemGenerated?: boolean;
    smartCount?: boolean;
    zeroStockItem?: boolean;
    includeInReports?: boolean;
    salesForecast?: boolean;
    wasteCheckSheet?: boolean;
    itemPrimaryCategoryOverrides?: ItemPrimaryCategoryOverride2[] | undefined;
}

export interface CreditRequestRag {
    storeNumber?: string | undefined;
    storeName?: string | undefined;
    orderNumber?: string | undefined;
    creditedAmount?: number | undefined;
}

export interface CreditRequestValue {
    storeNumber?: string | undefined;
    storeName?: string | undefined;
    orderNumber?: string | undefined;
    numberOfItems?: number;
    creditAmount?: number;
}

export interface CreditRequestsValuesResponse {
    id?: number;
    type?: number;
    creditRequestNumber?: string | undefined;
}

export interface GenericCreditRequestResponse {
    message?: string | undefined;
    success?: boolean;
}

export interface GetPurchaseOrderHeadersResponse {
    purchaseOrderHeadersCount?: number;
    purchaseOrderHeaders?: PurchaseOrderHeader[] | undefined;
}

export interface OrderTypesResponse {
    name?: string[] | undefined;
}

export interface PostReturnToVendorResponse {
    id?: number;
    purchaseOrderHeaderId?: number;
    message?: string | undefined;
    isSuccess?: boolean;
}

export interface PurchaseOrderHeader {
    id?: number;
    orderNumber?: string | undefined;
    ewsOrderNumber?: string | undefined;
    customisedOrderNumber?: string | undefined;
    storeNumber?: string | undefined;
    orderType?: string | undefined;
    deliveryDate?: string;
    invoiceNumber?: string | undefined;
    note?: string | undefined;
    packingSlipNumber?: string | undefined;
    acceptedDate?: string | undefined;
    isReceived?: boolean;
    receivedBy?: string | undefined;
    supplierName?: string | undefined;
    purchaseOrderLines?: PurchaseOrderLine[] | undefined;
    creditRequestExpected?: boolean;
    creditRequestStatus?: number;
    creditRequestSentDateTime?: string | undefined;
    creditRequestReceivedDateTime?: string | undefined;
    creditRequestNumber?: string | undefined;
    addedDate?: string | undefined;
    receivingDate?: string | undefined;
    showReason?: boolean;
    returnToVendorStatus?: number | undefined;
    erpOrderNumber?: string | undefined;
    totalCostPrice?: number;
}

export interface PurchaseOrderLine {
    id?: number;
    purchaseOrderHeaderId?: number;
    lineNumber?: string | undefined;
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    expectedUom?: string | undefined;
    expectedQuantity?: number;
    sequenceNumber?: number;
    receivedUom?: string | undefined;
    receivedQuantity?: number;
    note?: string | undefined;
    isSelected?: boolean;
    uomList?: Uom[] | undefined;
    creditedAmount?: number | undefined;
    creditedUom?: string | undefined;
    creditedQuantity?: number | undefined;
    reasonForCreditRequest?: string | undefined;
    tariffCode?: string | undefined;
    hasDiscrepancy?: boolean;
    unitCostPrice?: number;
    photos?: PurchaseOrderPhoto[] | undefined;
    insertedByUser?: boolean;
    isDepositFeeItem?: boolean;
    isDepositItem?: boolean;
    depositFeeItemNumber?: string | undefined;
    sku?: string | undefined;
}

export interface PurchaseOrderPhoto {
    fileName?: string | undefined;
    fileData?: string | undefined;
}

export interface PurchaseOrderRag {
    dateOfReceipt?: string;
    store?: string | undefined;
    orderNo?: string | undefined;
    orderId?: string | undefined;
    type?: string | undefined;
}

export interface ReturnToVendorHeaders {
    id?: number;
    purchaseOrderHeaderId?: number;
    status?: number;
    customerRmaNumber?: string | undefined;
    ewsOrderNumber?: string | undefined;
    deliveryNoteNumber?: string | undefined;
    documents?: string | undefined;
    orderType?: string | undefined;
    items?: ReturnToVendorHeaders_ReturnToVendorDetail[] | undefined;
}

export interface ReturnToVendorHeaders_ReturnToVendorDetail {
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    creditedQuantity?: number;
    creditedAmount?: number;
    creditedUom?: string | undefined;
    reasonForCreditRequest?: string | undefined;
}

export interface SupplierResponse {
    supplierName?: string[] | undefined;
}

export interface RAG {
    red?: number;
    amber?: number;
    green?: number;
}

export interface GetReasonsResponse {
    reasons?: Reason[] | undefined;
}

export interface Reason {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    actionType?: string | undefined;
    franchiseId?: number;
}

export interface ReportsResponse {
    reports?: ReportDto[] | undefined;
}

export interface GetReportsResponse {
    reports?: ReportDetails[] | undefined;
}

export interface ReportDetails {
    id?: number;
    name?: string | undefined;
    createdAt?: string;
    storeNumber?: string | undefined;
    storeName?: string | undefined;
    starbucksStoreNumber?: string | undefined;
    status?: ReportStatus;
}

export interface UploadDoNotCountItemsResponse {
    updatedItems?: number;
    failedItems?: number;
    failedDetails?: string[] | undefined;
}

export interface GetSourceTransactionsResponse {
    sourceTransactionID?: string | undefined;
    storeNumber?: string | undefined;
    transactionDate?: string;
    dataFiles?: SourceTransactionsDataFile[] | undefined;
}

export interface SourceTransactionsDataFile {
    fileName?: string | undefined;
    dataLines?: string[][] | undefined;
}

export interface GetStockResponse {
    totalCount?: number;
    categories?: string[] | undefined;
    stores?: KeyValuePair_2OfStringAndString[] | undefined;
    stock?: StockItem[] | undefined;
}

export interface StockItem {
    itemNumber?: string | undefined;
    imageUrl?: string | undefined;
    imageUrlLarge?: string | undefined;
    description?: string | undefined;
    primaryCategory?: string | undefined;
    uom?: string | undefined;
    quantity?: number;
    quantityInEaches?: number;
    costPrice?: number;
    totalCost?: number;
    storeNumber?: string | undefined;
    starbucksStoreNumber?: string | undefined;
    minimumQuantity?: number;
    isBom?: boolean;
    isStockItem?: boolean;
    isPosEnabled?: boolean;
    isNew?: boolean;
}

export interface BulkAddResponse2 {
    success?: string[] | undefined;
    fails?: string[] | undefined;
}

export interface GenerateStockCheckResponse {
    success?: number;
    fails?: number;
    queued?: boolean;
    storeCount?: number | undefined;
}

export interface GetStockCheckUomResponse {
    stockCheckUoms?: StockCheckUom[] | undefined;
}

export interface StockCheckDetails {
    stockCheck?: StockCheck;
    lastPosDate?: string | undefined;
    hasPosData?: boolean;
    maxToleranceWarningValue?: number | undefined;
    allCountZonesEnabled?: boolean | undefined;
    orderedUoms?: string[] | undefined;
}

export interface StockCheckScheduleDetails {
    stockCheckSchedule?: StockCheckScheduleDetail;
    approverEmails?: string[] | undefined;
    stores?: Store2[] | undefined;
}

export interface BidfoodWebshopCredentials {
    username?: string | undefined;
    password?: string | undefined;
}

export interface Store {
    storeNumber?: string | undefined;
    starbucksStoreNumber?: string | undefined;
    storeName?: string | undefined;
    storeGroup?: string | undefined;
    legalEntity?: string | undefined;
    franchiseId?: number;
    franchiseName?: string | undefined;
}

export interface StoreFranchiseNamesResponse {
    franchiseNames?: string[] | undefined;
}

export interface StoreListResponse {
    stores?: Store[] | undefined;
}

export interface SuccessResponse_1OfAutomatedTaskDetails {
    data?: AutomatedTaskDetails;
}

export interface SuccessResponse_1OfGetConfigurationResponse {
    data?: GetConfigurationResponse;
}

export interface SuccessResponse_1OfGetInvoicesResponse {
    data?: GetInvoicesResponse;
}

export interface SuccessResponse_1OfInvoice {
    data?: Invoice;
}

export interface SuccessResponse_1OfGetItemsResponse {
    data?: GetItemsResponse;
}

export interface SuccessResponse_1OfItem {
    data?: Item;
}

export interface SuccessResponse_1OfLocationResponse {
    data?: LocationResponse;
}

export interface SuccessResponse_1OfPostLocationResponse {
    data?: PostLocationResponse;
}

export interface SuccessResponse_1OfNotification {
    data?: Notification2;
}

export interface SuccessResponse_1OfPagedData_1OfGetPaperPackagingResponse {
    data?: PagedData_1OfGetPaperPackagingResponse;
}

export interface SuccessResponse_1OfPagedData_1OfGetPosMappingResponse {
    data?: PagedData_1OfGetPosMappingResponse;
}

export interface SuccessResponse_1OfPagedData_1OfProductTransactionSearch {
    data?: PagedData_1OfProductTransactionSearch;
}

export interface SuccessResponse_1OfPredictiveOrderingDetails {
    data?: PredictiveOrderingDetails;
}

export interface SuccessResponse_1OfBulkAddResponse {
    data?: BulkAddResponse2;
}

export interface SuccessResponse_1OfPrimaryCategory {
    data?: PrimaryCategory2;
}

export interface SuccessResponse_1OfGetPurchaseOrderHeadersResponse {
    data?: GetPurchaseOrderHeadersResponse;
}

export interface SuccessResponse_1OfOrderTypesResponse {
    data?: OrderTypesResponse;
}

export interface SuccessResponse_1OfPostReturnToVendorResponse {
    data?: PostReturnToVendorResponse;
}

export interface SuccessResponse_1OfPurchaseOrderHeader {
    data?: PurchaseOrderHeader;
}

export interface SuccessResponse_1OfReturnToVendorHeaders {
    data?: ReturnToVendorHeaders;
}

export interface SuccessResponse_1OfSupplierResponse {
    data?: SupplierResponse;
}

export interface SuccessResponse_1OfRAG {
    data?: RAG;
}

export interface SuccessResponse_1OfGetReasonsResponse {
    data?: GetReasonsResponse;
}

export interface SuccessResponse_1OfReportsResponse {
    data?: ReportsResponse;
}

export interface SuccessResponse_1OfGetReportsResponse {
    data?: GetReportsResponse;
}

export interface SuccessResponse_1OfGetSourceTransactionsResponse {
    data?: GetSourceTransactionsResponse;
}

export interface SuccessResponse_1OfGetStockResponse {
    data?: GetStockResponse;
}

export interface SuccessResponse_1OfStockItem {
    data?: StockItem;
}

export interface SuccessResponse_1OfGetStockCheckUomResponse {
    data?: GetStockCheckUomResponse;
}

export interface SuccessResponse_1OfStockCheckDetails {
    data?: StockCheckDetails;
}

export interface SuccessResponse_1OfStockCheckScheduleDetails {
    data?: StockCheckScheduleDetails;
}

export interface SuccessResponse_1OfStoreFranchiseNamesResponse {
    data?: StoreFranchiseNamesResponse;
}

export interface SuccessResponse_1OfStoreListResponse {
    data?: StoreListResponse;
}

export interface SuccessResponse_1OfSuccessResponse_1OfNotification {
    data?: SuccessResponse_1OfNotification;
}

export interface SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict {
    data?: SuccessResponse_1OfIEnumerable_1OfDistrict;
}

export interface SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification {
    data?: SuccessResponse_1OfIEnumerable_1OfNotification;
}

export interface SuccessResponse_1OfGetTasksResponse {
    data?: GetTasksResponse;
}

export interface SuccessResponse_1OfGetTransfersResponse {
    data?: GetTransfersResponse;
}

export interface SuccessResponse_1OfGetUomsResponse {
    data?: GetUomsResponse;
}

export interface SuccessResponse_1OfUserListResponse {
    data?: UserListResponse;
}

export interface SuccessResponse_1OfUser {
    data?: User;
}

export interface SuccessResponse_1OfWasteCheckSheetResponse {
    data?: WasteCheckSheetResponse;
}

export interface SuccessResponse_1OfGetItemsResponseDto {
    data?: GetItemsResponseDto;
}

export interface SuccessResponse_1OfFranchiseOrderTypes {
    data?: FranchiseOrderTypes;
}

export interface SuccessResponse_1OfPagedData_1OfStockCheck {
    data?: PagedData_1OfStockCheck;
}

export interface SuccessResponse_1OfPagedData_1OfWasteHeaders {
    data?: PagedData_1OfWasteHeaders;
}

export interface SuccessResponse_1OfPredictiveOrderingDate {
    data?: PredictiveOrderingDate2;
}

export interface SuccessResponse_1OfReportDto {
    data?: ReportDto;
}

export interface SuccessResponse_1OfTransferHeader {
    data?: TransferHeader;
}

export interface SuccessResponse_1OfTransportCost {
    data?: TransportCost;
}

export interface SuccessResponse_1OfBoolean {
    data?: boolean;
}

export interface SuccessResponse_1OfIEnumerable_1OfDistrict {
    data?: District[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfFranchise {
    data?: Franchise[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfInvoiceRag {
    data?: InvoiceRag[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfLocationResponse {
    data?: LocationResponse[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfMaterial {
    data?: Material[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfNotification {
    data?: Notification2[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfPersona {
    data?: Persona[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfCreditRequestRag {
    data?: CreditRequestRag[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfCreditRequestValue {
    data?: CreditRequestValue[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfCreditRequestsValuesResponse {
    data?: CreditRequestsValuesResponse[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag {
    data?: PurchaseOrderRag[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse {
    data?: GetTransactionTypeResponse[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfPosFeedLastReceived {
    data?: PosFeedLastReceived[] | undefined;
}

export interface SuccessResponse_1OfIEnumerable_1OfStockCheckRAG {
    data?: StockCheckRAG[] | undefined;
}

export interface SuccessResponse_1OfIList_1OfAggregationsDto {
    data?: AggregationsDto[] | undefined;
}

export interface SuccessResponse_1OfIList_1OfColumnMetricDto {
    data?: ColumnMetricDto[] | undefined;
}

export interface SuccessResponse_1OfIList_1OfDataGroupDto {
    data?: DataGroupDto[] | undefined;
}

export interface SuccessResponse_1OfIList_1OfFilterMetricDto {
    data?: FilterMetricDto[] | undefined;
}

export interface SuccessResponse_1OfIList_1OfFilterOperatorsDto {
    data?: FilterOperatorsDto[] | undefined;
}

export interface SuccessResponse_1OfIList_1OfLogicalOperatorDto {
    data?: LogicalOperatorDto[] | undefined;
}

export interface SuccessResponse_1OfList_1OfItemDailyHistory {
    data?: ItemDailyHistory[] | undefined;
}

export interface SuccessResponse_1OfList_1OfCostHistory {
    data?: CostHistory[] | undefined;
}

export interface SuccessResponse_1OfList_1OfItem {
    data?: Item[] | undefined;
}

export interface SuccessResponse_1OfList_1OfPrimaryCategory {
    data?: PrimaryCategory2[] | undefined;
}

export interface SuccessResponse_1OfList_1OfUser {
    data?: User[] | undefined;
}

export interface SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate {
    data?: AutomatedTaskPreviewDate[] | undefined;
}

export interface SuccessResponse_1OfList_1OfAutomatedTask {
    data?: AutomatedTask[] | undefined;
}

export interface SuccessResponse_1OfList_1OfItemRecipeSummary {
    data?: ItemRecipeSummary[] | undefined;
}

export interface SuccessResponse_1OfList_1OfPrimaryCategoryStockCount {
    data?: PrimaryCategoryStockCount[] | undefined;
}

export interface SuccessResponse_1OfList_1OfStockCheckScheduleDetail {
    data?: StockCheckScheduleDetail[] | undefined;
}

export interface SuccessResponse_1OfList_1OfTransportCost {
    data?: TransportCost[] | undefined;
}

export interface SuccessResponse_1OfList_1OfNetSales {
    data?: NetSales[] | undefined;
}

export interface SuccessResponse_1OfList_1OfVoidedTransaction {
    data?: VoidedTransaction[] | undefined;
}

export interface SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString {
    data?: KeyValuePair_2OfInt32AndString[] | undefined;
}

export interface SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString {
    data?: KeyValuePair_2OfStringAndString[] | undefined;
}

export interface SuccessResponse_1OfList_1OfDateTime {
    data?: string[] | undefined;
}

export interface SuccessResponse_1OfDateTime {
    data?: string;
}

export interface SuccessResponse_1OfInt32 {
    data?: number;
}

export interface SuccessResponse_1OfObject {
    data?: any | undefined;
}

export interface GetTasksResponse {
    totalCount?: number;
    tasks?: InventoryTask[] | undefined;
}

export interface InventoryTask {
    taskType?: KeyValuePair_2OfStringAndString;
    percentageComplete?: number;
    startDate?: string | undefined;
    completedDate?: string | undefined;
    resourceId?: number;
    description?: string | undefined;
}

export interface GetTransactionTypeResponse {
    id?: number;
    name?: string | undefined;
    displayName?: string | undefined;
    enabled?: boolean;
    direction?: string | undefined;
    type?: string | undefined;
    enabledDuplicateValidation?: boolean;
    franchiseId?: number;
}

export interface MaterialSearch {
    transactionDay?: number;
    materialId?: number;
    productId?: number;
    storeNumber?: string | undefined;
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    costPrice?: number;
    quantity?: number;
    uom?: string | undefined;
    note?: string | undefined;
    originalQuantity?: number;
    originalUom?: string | undefined;
    match?: boolean;
}

export type OrderType = 0 | 1 | 2 | 3;

export interface PosFeedLastReceived {
    storeNumber?: string | undefined;
    storeName?: string | undefined;
    date?: string | undefined;
}

export interface ProductTransactionSearch {
    transactionDay?: number;
    productId?: number;
    transactionId?: number;
    productItemNumber?: string | undefined;
    productItemDescription?: string | undefined;
    productQuantity?: number;
    productUom?: string | undefined;
    discountReason?: string | undefined;
    totalSalePriceNet?: number | undefined;
    totalSalePriceGross?: number | undefined;
    totalDiscountNet?: number | undefined;
    totalDiscountGross?: number | undefined;
    costPrice?: number;
    productNote?: string | undefined;
    isBom?: boolean;
    materials?: MaterialSearch[] | undefined;
    storeNumber?: string | undefined;
    type?: string | undefined;
    source?: string | undefined;
    direction?: string | undefined;
    reason?: string | undefined;
    sourceTransactionId?: string | undefined;
    transactionTime?: string;
    createdBy?: string | undefined;
    orderType?: OrderType;
    createdAt?: string;
    match?: boolean;
    isVoided?: boolean;
}

export interface GetTransfersResponse {
    totalCount?: number;
    transfers?: TransferSummary[] | undefined;
}

export interface GetUomsResponse {
    uoms?: Uom[] | undefined;
}

export interface Uom {
    code?: string | undefined;
    description?: string | undefined;
    class?: string | undefined;
    type?: string | undefined;
    toPrimaryConversion?: number;
}

export interface BulkUserActionResponse {
    email?: string | undefined;
    success?: boolean;
    error?: string | undefined;
}

export interface User {
    id?: number;
    emailAddress?: string | undefined;
    userLevel?: string | undefined;
    franchiseName?: string | undefined;
    franchises?: Franchise2[] | undefined;
    persona?: Persona;
    stores?: Store[] | undefined;
    district?: DistrictSummary;
    allStores?: boolean;
}

export interface UserListResponse {
    users?: User[] | undefined;
}

export interface UserSmall {
    id?: number;
    emailAddress?: string | undefined;
    userLevel?: UserLevel;
    franchiseName?: string | undefined;
}

export interface WasteCheckSheetResponse {
    wasteHeaders?: WasteHeaders;
}

export interface ConversionDto {
    itemId?: string | undefined;
    itemDescription?: string | undefined;
    conversionNumber?: number;
    fromUom?: string | undefined;
    fromUomDescription?: string | undefined;
    fromUomClass?: string | undefined;
    toUom?: string | undefined;
    toUomDescription?: string | undefined;
    toUomClass?: string | undefined;
}

export interface GetConversionsResponseDto {
    conversionsCount?: number;
    conversions?: ConversionDto[] | undefined;
}

export interface GetExistingConversionsResponseDto {
    conversions?: StoresConversion[] | undefined;
}

export interface ImportConversionsRequestDto {
    name?: string | undefined;
    key?: string | undefined;
    conversions?: UomConversionItemDto[] | undefined;
}

export interface UomConversionItemDto {
    conversionGroupId?: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    conversionNumber?: number;
    fromUom?: string | undefined;
    fromUomDescription?: string | undefined;
    fromUomClass?: string | undefined;
    fromUomType?: string | undefined;
    toUom?: string | undefined;
    toUomDescription?: string | undefined;
    toUomClass?: string | undefined;
    toUomType?: string | undefined;
}

export interface UpdateCostPricesByEachPriceResponseDto {
    unknownStoreNumbers?: string[] | undefined;
    missingItemNumbers?: string[] | undefined;
    failedToConvertCostPriceToPrimaryUomItemNumbers?: string[] | undefined;
}

export interface UpdateCostPricesByPrimaryUomPriceRequestDto {
    franchiseName?: string[] | undefined;
    storeNumber?: string[] | undefined;
    csvFile: string;
}

export interface UpdateCostPricesByPrimaryUomPriceMatchRequestDto {
    storeNumber?: string[] | undefined;
    csvFile: string;
}

export interface UpdateQuantityOnHandRequestDto {
    storeNumber?: string | undefined;
    itemNumbers?: string[] | undefined;
}

export interface UpdateQuantityOnHandResponseDto {
}

export interface UpdateStoreNumberRequestDto {
    currentStoreNumber: string;
    newStoreNumber: string;
    runAsBackgroundTask?: boolean;
}

export interface UpdateStoreNumberResponseDto {
    storeNumber?: string | undefined;
    oldStoreNumber?: string | undefined;
}

export interface CreateMadeInStoreItemRequestDto {
    type?: MadeInStoreType;
    description?: string | undefined;
    itemNumber?: string | undefined;
    primaryUom?: string | undefined;
    uomConversion?: number;
    unitCostPrice?: number;
    weightNet?: number;
    isAllStores?: boolean;
    stores?: string[] | undefined;
    category?: string | undefined;
    components?: ItemComponent[] | undefined;
}

export interface GetItemsRequestDto {
    itemNumber?: string | undefined;
    storeNumbers?: string[] | undefined;
}

export interface GetItemsResponseDto {
    items?: StoreItem[] | undefined;
}

export interface AdjustPurchaseOrderRequestDto {
    id?: number;
    receivedType?: ReceivedType;
    alterations?: PurchaseOrderAlterationDto[] | undefined;
}

export interface PurchaseOrderAlterationDto {
    itemNumber?: string | undefined;
    note?: string | undefined;
    isSelected?: boolean;
    oldQuantity?: number;
    oldQuantityUom?: string | undefined;
    newQuantity?: number;
    newQuantityUom?: string | undefined;
    unitCostPrice?: number;
    oldExpectedQuantity?: number;
    newExpectedQuantity?: number;
    sequenceNumber?: number;
}

export interface ForecastLineDto {
    sku?: string | undefined;
    item?: string | undefined;
    caseQuantity?: number;
    primaryUom?: string | undefined;
    stockOnHand?: number;
    mondaySales?: number;
    tuesdaySales?: number;
    wednesdaySales?: number;
    thursdaySales?: number;
    fridaySales?: number;
    saturdaySales?: number;
    sundaySales?: number;
    weeklyTotalSales?: number;
}

export interface GetForecastResponseDto {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: ForecastLineDto[] | undefined;
}

export interface GetItemCategoriesResponseDto {
    categories?: ItemCategoryDto[] | undefined;
}

export interface ItemCategoryDto {
    name?: string | undefined;
    key?: number;
}

export interface GetWeekPeriodsResponseDto {
    weekPeriods?: WeekPeriodDto[] | undefined;
}

export interface WeekPeriodDto {
    start?: string;
    end?: string;
    key?: number;
}

export interface GetServerDateTimeResponseDto {
    localDateTime?: string | undefined;
    endOfDay?: string | undefined;
}

export interface ActivateUserRequestDto {
    password: string;
}

export interface CreateUserRequestDto {
    emailAddress?: string | undefined;
    franchiseName?: string | undefined;
    personaId?: number | undefined;
    useNewUI?: boolean | undefined;
    districtId?: number | undefined;
    stores?: string[] | undefined;
    franchiseIds?: number[] | undefined;
    allStores?: boolean;
}

export interface ResetPasswordRequestDto {
    emailAddress?: string | undefined;
}

export type AuditLogSystemArea = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;

export type ConfigurationName = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 30 | 31 | 32 | 33 | 34 | 35 | 36 | 37 | 38 | 39 | 40 | 41 | 42 | 43 | 44 | 45 | 46 | 47 | 48 | 49 | 50;

export type CostPriceModel = 0 | 1 | 2 | 3;

export type InvoiceType = 0 | 1;

export type ItemChangeType = 0 | 1 | 2 | 3 | 4 | 5;

export type ItemFeedChangeStatus = 0 | 1 | 2;

export type MadeInStoreType = 0 | 1 | 2;

export type NotificationType = 0 | 1;

export type PodWidgetType = 0 | 1 | 2 | 3 | 4;

export type ReceivedType = 0 | 1 | 2 | 3;

export type ReportStatus = 0 | 1 | 2 | 3;

export type Roles = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 30 | 31 | 32 | 33 | 34 | 35 | 36 | 37 | 38 | 39 | 40 | 41 | 42 | 43 | 44 | 45 | 46 | 47 | 48 | 49 | 50 | 51 | 52 | 53 | 54 | 55 | 56 | 57 | 58 | 59 | 60 | 61 | 62 | 63 | 64 | 65 | 66 | 67 | 68 | 69 | 70 | 71 | 72 | 73 | 74 | 75 | 76 | 77;

export type ScheduleRecurrenceFrequency = 1 | 7;

export type StockCheckItemScanStatus = 0 | 1;

export type StockCheckScanStatus = 0 | 1 | 2;

export type StockCheckStatus = 0 | 1 | 2 | 3 | 4;

export type UserLevel = 0 | 1 | 2;

export interface Result {
    readonly success?: boolean;
    readonly reason?: string | undefined;
}

export interface ActualTheorySummary {
    storeNumber?: string | undefined;
    storeName?: string | undefined;
    from?: string;
    to?: string;
    waste?: number;
    missing?: number;
    variance?: number;
}

export interface AutomatedTask {
    id?: number;
    name?: string | undefined;
    userId?: number;
    isActive?: boolean;
    emailUser?: boolean;
    additionalEmails?: string | undefined;
    saveToUserReports?: boolean;
    taskType?: string | undefined;
    taskData?: string | undefined;
    schedules?: AutomatedTaskSchedule[] | undefined;
}

export interface AutomatedTaskPreviewDate {
    generateAt?: string;
    reportFrom?: string | undefined;
    reportTo?: string | undefined;
}

export interface AutomatedTaskSchedule {
    id?: number;
    automatedTaskId?: number;
    isActive?: boolean;
    startDate?: string;
    endDate?: string | undefined;
    recurrenceFrequency?: number;
    recurrenceInterval?: number;
    scheduleType?: number;
    scheduledDayOfMonth?: number;
    nextRunDate?: string | undefined;
    lastGenerated?: string | undefined;
}

export interface UomConversionItem {
    itemNumber?: string | undefined;
    description?: string | undefined;
    conversionNumber?: number;
    fromUom?: string | undefined;
    fromUomDescription?: string | undefined;
    fromUomClass?: string | undefined;
    fromUomType?: string | undefined;
    toUom?: string | undefined;
    toUomDescription?: string | undefined;
    toUomClass?: string | undefined;
    toUomType?: string | undefined;
}

export interface FranchiseOrderTypes {
    id?: number;
    franchiseName?: string | undefined;
    orderType?: string | undefined;
    overReceivingDisabled?: boolean;
}

export interface Franchise2 {
    franchiseId?: number;
    franchiseName?: string | undefined;
    active?: boolean;
}

export interface GroupedItemFeedChange {
    type?: ItemChangeType;
    description?: string | undefined;
    ids?: number[] | undefined;
}

export interface Item2 {
    id?: number;
    itemNumber?: string | undefined;
    storeNumber?: string | undefined;
    description?: string | undefined;
    uom?: string | undefined;
    status?: string | undefined;
    primaryCategory?: string | undefined;
    familyGroupName?: string | undefined;
    pickPackUom?: string | undefined;
    costPrice?: number;
    imageUrl?: string | undefined;
    imageUrlLarge?: string | undefined;
    weightNet?: number;
    isBom?: boolean;
    isStockItem?: boolean;
    isSaleItem?: boolean;
    isPosEnabled?: boolean;
    itemVolume?: number | undefined;
    isMadeInStore?: boolean;
    tariffCode?: string | undefined;
    sku?: string | undefined;
    vatRate?: number | undefined;
    isDepositFeeItem?: boolean;
    isDepositItem?: boolean;
    depositFeeItemNumber?: string | undefined;
    isAllowPartialUomTransactions?: boolean;
}

export interface ItemCompare {
    changeData?: ItemFeedChange;
    showItem?: boolean;
    showComponent?: boolean;
    showMessage?: boolean;
    message?: string | undefined;
    itemCurrently?: Item2;
    itemAfterUpdate?: Item2;
    componentItem?: Item2;
    componentCurrently?: ItemComponent2;
    componentAfterUpdate?: ItemComponent2;
}

export interface ItemComponent2 {
    itemId?: number;
    componentItemId?: number;
    componentItemNumber?: string | undefined;
    componentDescription?: string | undefined;
    uom?: string | undefined;
    quantity?: number;
    weight?: number;
    volume?: number | undefined;
    storeNumber?: string | undefined;
    storeName?: string | undefined;
    isCreated?: boolean;
}

export interface ItemFeedChange {
    itemFeedChangeId?: number;
    storeNumber?: string | undefined;
    itemNumber?: string | undefined;
    componentItemNumber?: string | undefined;
    feedDate?: string;
    status?: ItemFeedChangeStatus;
    type?: ItemChangeType;
    data?: ItemRecipe[] | undefined;
    componentData?: ItemRecipeComponent;
    appliedBy?: string | undefined;
    appliedDate?: string | undefined;
    modifiedFields?: string[] | undefined;
    description?: string | undefined;
}

export interface ItemRecipe {
    itemNumber?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    imageUrlLarge?: string | undefined;
    primaryCategory?: string | undefined;
    familyGroupName?: string | undefined;
    status?: string | undefined;
    uom?: string | undefined;
    pickPackUom?: string | undefined;
    weightNet?: number;
    orderTypes?: number[] | undefined;
    suppliers?: string[] | undefined;
    isBom?: boolean;
    isPosEnabled?: boolean;
    isSaleItem?: boolean;
    isStockItem?: boolean;
    components?: ItemRecipeComponent[] | undefined;
    itemVolume?: number | undefined;
    tariffCode?: string | undefined;
    sku?: string | undefined;
    vatRate?: number | undefined;
    isDepositFeeItem?: boolean;
    isDepositItem?: boolean;
    depositFeeItemNumber?: string | undefined;
    isAllowPartialUomTransactions?: boolean;
}

export interface ItemRecipeComponent {
    itemNumber?: string | undefined;
    quantity?: number;
    weight?: number;
    volume?: number | undefined;
}

export interface ItemRecipeSummary {
    item?: Item2;
    storeName?: string | undefined;
    franchiseName?: string | undefined;
    components?: ItemComponent2[] | undefined;
    conversion?: UomConversionItem;
}

export interface MadeInStoreComponent {
    componentId?: number;
    componentItemNumber?: string | undefined;
    componentDescription?: string | undefined;
    uom?: string | undefined;
    quantity?: number;
    stockOnHandQuantity?: number | undefined;
    totalYield?: number | undefined;
}

export interface MadeInStoreItem {
    id?: number;
    store?: string | undefined;
    primaryUom?: string | undefined;
    itemNumber?: string | undefined;
    description?: string | undefined;
    stockOnHandQuantity?: number | undefined;
    maximumQuantity?: number;
    quantity?: number | undefined;
    isExpanded?: boolean;
    createdBy?: string | undefined;
    madeInStoreComponents?: MadeInStoreComponent[] | undefined;
}

export interface StoresConversion {
    storeNumbers?: string[] | undefined;
    conversion?: UomConversionItem[] | undefined;
}

export interface PagedData_1OfStockCheck {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: StockCheck[] | undefined;
}

export interface PagedData_1OfWasteHeaders {
    totalCount?: number;
    skip?: number;
    take?: number;
    data?: WasteHeaders[] | undefined;
}

export interface DeleteRoleFromPersonasResponse {
    dryRun?: boolean;
    roleId?: number;
    roleName?: string | undefined;
    affectedPersonasCount?: number;
    affectedUsersCount?: number;
    personaIdsUpdated?: number[] | undefined;
    affectedUsersInAuth0?: UserInfo[] | undefined;
}

export interface UpdateUsersInAuth0Response {
    dryRun?: boolean;
    isRunningProcessInBackground?: boolean;
    affectedPersonasCount?: number;
    affectedUsersCount?: number;
    personaIds?: number[] | undefined;
    personaIdsNotUpdated?: number[] | undefined;
    updatedUsersInAuth0?: UserInfo[] | undefined;
    error?: string | undefined;
}

export interface UserInfo {
    id?: number;
    emailAddress?: string | undefined;
}

export interface PodWidgetData {
    value?: string | undefined;
    progressPercentage?: number | undefined;
    changeFromPreviousPeriodPercentage?: number | undefined;
}

export interface PredictiveOrderingDate2 {
    date?: string;
    deliveryTypes?: PredictiveOrderingDeliveryType2[] | undefined;
    expectedSalesValue?: number;
    salesValueAWeekAgo?: number | undefined;
    salesValueAverage?: number | undefined;
    warnings?: string[] | undefined;
    totalStockOnHandValue?: number | undefined;
}

export interface PredictiveOrderingDelivery {
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    orderableUomQuantity?: number;
    value?: number;
    unitsSoldDaily?: number;
    stockOnHandQuantityInPrimaryUom?: number;
    orderableUom?: string | undefined;
    primaryUom?: string | undefined;
    orderableUomQuantityOnExistingOrders?: number;
}

export interface PredictiveOrderingDeliveryType2 {
    orderType?: number;
    selected?: boolean;
    totalDeliveryValue?: number | undefined;
    items?: PredictiveOrderingDelivery[] | undefined;
}

export interface ItemPrimaryCategoryOverride3 {
    primaryCategoryId?: number;
    itemNumber?: string | undefined;
}

export interface PrimaryCategoryStockCount {
    id?: number;
    franchiseId?: number;
    primaryCategoryName?: string | undefined;
    systemGenerated?: boolean;
    smartCount?: boolean;
    zeroStockItem?: boolean;
    includeInReports?: boolean;
    salesForecast?: boolean;
    wasteCheckSheet?: boolean;
    itemCount?: number;
    stockItemCount?: number;
    itemOverrideCount?: number;
    itemPrimaryCategoryOverrides?: ItemPrimaryCategoryOverride3[] | undefined;
}

export interface AggregationsDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export interface ColumnMetricDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    dataGroupId?: number | undefined;
    isDefaultField?: boolean;
}

export interface DataGroupDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export interface FilterMetricDto {
    id?: number;
    name?: string | undefined;
    dataType?: string | undefined;
    description?: string | undefined;
    fieldType?: string | undefined;
    dataGroupId?: number | undefined;
    isDefaultField?: boolean;
}

export interface FilterOperatorsDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export interface LogicalOperatorDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export interface ReportColumnDto {
    id?: number;
    reportId?: number;
    metricId?: number;
}

export interface ReportDto {
    id?: number;
    storeNumber?: string | undefined;
    reportName?: string | undefined;
    aggregationId?: number | undefined;
    dataGroupId?: number | undefined;
    createdBy?: number;
    createdDate?: string;
    lastModifiedDate?: string | undefined;
    reportColumns?: ReportColumnDto[] | undefined;
    reportFilterGroups?: ReportFilterGroupDto[] | undefined;
    reportFilterGroupLinks?: ReportFilterGroupLinkDto[] | undefined;
    reportFilters?: ReportFilterDto[] | undefined;
}

export interface ReportFilterDto {
    id?: number;
    reportId?: number;
    filterMetricId?: number;
    operatorId?: number;
    value?: string | undefined;
    uiId?: number;
}

export interface ReportFilterGroupDto {
    id?: number;
    reportId?: number;
    reportFilterGroupFilters?: ReportFilterGroupFilterDto[] | undefined;
}

export interface ReportFilterGroupFilterDto {
    id?: number;
    groupId?: number;
    filterId?: number;
    logicalOperatorId?: number | undefined;
    filter?: ReportFilterDto;
}

export interface ReportFilterGroupLinkDto {
    id?: number;
    reportId?: number;
    group1Id?: number;
    group2Id?: number;
    logicalOperatorId?: number;
}

export interface StockCheck {
    id?: number;
    name?: string | undefined;
    storeNumber?: string | undefined;
    status?: StockCheckStatus;
    plannedCountDate?: string;
    isSmartCount?: boolean;
    createdBy?: string | undefined;
    parentId?: number | undefined;
    canMergeCount?: boolean;
    lockTillCountDay?: boolean;
    lockTillHour?: number;
    updateSmartCountItems?: boolean;
    approver?: string | undefined;
    selectedUomsOnGeneration?: string | undefined;
    autoApproveDayOfMonth?: number | undefined;
    erpSubmittedDate?: string | undefined;
    erpResponseCode?: string | undefined;
    isAllowPartialUomTransactions?: boolean;
    tolerancePercentage?: number | undefined;
    toleranceValue?: number | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    countedBy?: string | undefined;
    approvedBy?: string | undefined;
    approvedDate?: string | undefined;
    reorderEnabled?: boolean | undefined;
    documentDetailsId?: number | undefined;
    canStartCount?: boolean;
    unlockTimeUtc?: string | undefined;
    items?: StockCheckItem[] | undefined;
    scanAudits?: StockCheckScanAudit[] | undefined;
    hasScanAuditData?: boolean;
    categories?: StockCheckCategory[] | undefined;
}

export interface StockCheckCategory {
    stockCheckId?: number;
    primaryCategoryId?: number;
}

export interface StockCheckItem {
    id?: number;
    stockCheckId?: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    primaryUom?: string | undefined;
    isApproved?: boolean | undefined;
    isAllowPartialUomTransactions?: boolean;
    rowNumber?: number | undefined;
    itemLocation?: StockCheckItem_StockCheckItemLocationValue[] | undefined;
    tolerancePercentage?: number | undefined;
    toleranceValue?: number | undefined;
    quantityOnHand?: number | undefined;
    costPriceOnHand?: number | undefined;
    countQuantityTotal?: number | undefined;
    outsideTolerance?: boolean;
    scanStatus?: StockCheckItemScanStatus;
    isNew?: boolean;
    itemValues?: StockCheckItemValue[] | undefined;
    itemLocationValues?: StockCheckItemLocationValue[] | undefined;
    readonly varianceValue?: number | undefined;
    readonly varianceQuantity?: number | undefined;
    readonly variancePercentage?: number | undefined;
}

export interface StockCheckItem_StockCheckItemLocationValue {
    id?: number;
    stockCheckItemId?: number;
    locationId?: number;
    uom?: string | undefined;
    conversionToPrimary?: number;
    conversionToEach?: number | undefined;
    countQuantity?: number | undefined;
    rowNumber?: number | undefined;
}

export interface StockCheckItemLocationValue {
    id?: number;
    stockCheckItemId?: number;
    locationId?: number;
    uom?: string | undefined;
    conversionToPrimary?: number;
    conversionToEach?: number | undefined;
    countQuantity?: number | undefined;
    rowNumber?: number | undefined;
}

export interface StockCheckItemValue {
    id?: number;
    stockCheckItemId?: number;
    uom?: string | undefined;
    conversionToPrimary?: number;
    conversionToEach?: number | undefined;
    countQuantity?: number | undefined;
}

export interface StockCheckRAG {
    id?: number;
    name?: string | undefined;
    storeNumber?: string | undefined;
    storeName?: string | undefined;
    status?: StockCheckStatus;
    plannedCountDate?: string;
}

export interface StockCheckScanAudit {
    id?: number;
    stockCheckId?: number;
    stockCheckItemId?: number | undefined;
    scannedBy?: string | undefined;
    scannedOn?: string;
    status?: StockCheckScanStatus;
    barcode?: string | undefined;
    stockCheck?: StockCheck;
    stockCheckItem?: StockCheckItem;
}

export interface StockCheckSchedule {
    id?: number;
    stockCheckScheduleDetailId?: number;
    storeNumber?: string | undefined;
    isActive?: boolean;
    generationDayOffset?: number;
    startDate?: string | undefined;
    recurrenceFrequency?: ScheduleRecurrenceFrequency;
    recurrenceInterval?: number;
    scheduleType?: number;
    scheduledDayOfMonth?: number;
    stockCheckLastCreated?: string | undefined;
    allStoresSelected?: boolean;
    multiStoresGroupId?: number | undefined;
    autoApproveDayOfMonth?: number | undefined;
}

export interface StockCheckScheduleCategory {
    stockCheckScheduleDetailId?: number;
    primaryCategoryId?: number;
    primaryCategoryName?: string | undefined;
}

export interface StockCheckScheduleDetail {
    id?: number;
    name?: string | undefined;
    franchise?: number;
    isActive?: boolean;
    tolerancePercentage?: number | undefined;
    toleranceValue?: number | undefined;
    isSmartCount?: boolean;
    canMergeCount?: boolean;
    lockTillCountDay?: boolean;
    lockTillHour?: number;
    updateSmartCountItems?: boolean;
    approver?: string | undefined;
    creationDate?: string | undefined;
    nextUpcomingCount?: string | undefined;
    schedules?: StockCheckSchedule[] | undefined;
    items?: StockCheckScheduleItem[] | undefined;
    categories?: StockCheckScheduleCategory[] | undefined;
}

export interface StockCheckScheduleItem {
    id?: number;
    stockCheckScheduleDetailId?: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    tolerancePercentage?: number | undefined;
    toleranceValue?: number | undefined;
}

export interface StockCheckUom {
    id?: number;
    uom?: string | undefined;
    visible?: boolean;
    orderNumber?: number | undefined;
    franchiseId?: number | undefined;
}

export interface DeliverySchedule2 {
    storeNumber?: string | undefined;
    orderType?: number;
    cutOffDate?: string;
    deliveryDate?: string;
    supplierNumber?: string | undefined;
}

export interface Store2 {
    storeNumber?: string | undefined;
    starbucksStoreNumber?: string | undefined;
    storeName?: string | undefined;
    storeGroup?: string | undefined;
    legalEntity?: string | undefined;
    country?: string | undefined;
    town?: string | undefined;
    creditRequestsEnabled?: boolean;
    creditRequestsRequirePhotographicEvidence?: boolean;
    deliverySchedules?: DeliverySchedule2[] | undefined;
    storeActivationDate?: string | undefined;
    franchiseId?: number;
    franchiseName?: string | undefined;
    erpLocationID?: string | undefined;
}

export interface UpdateStoreName {
    storeNumber?: string | undefined;
    storeName?: string | undefined;
}

export interface PatchTransactionTypeRequest {
    type?: string | undefined;
    enabled?: boolean;
    enabledDuplicateValidation?: boolean;
}

export interface TransferDetail {
    id?: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    primaryUom?: string | undefined;
    requestedQuantity?: number;
    receivedQuantity?: number | undefined;
    requestedValue?: number;
    receivedValue?: number | undefined;
    isDepositFeeItem?: boolean;
    isDepositItem?: boolean;
    depositFeeItemNumber?: string | undefined;
    sku?: string | undefined;
    isAllowPartialUomTransactions?: boolean;
}

export interface TransferHeader {
    transferId?: number;
    transferDate?: string;
    transferType?: string | undefined;
    storeName?: string | undefined;
    totalRequestedValue?: number;
    totalReceivedValue?: number;
    note?: string | undefined;
    isDeleted?: boolean;
    acceptedDate?: string | undefined;
    transferDetails?: TransferDetail[] | undefined;
}

export interface TransferSummary {
    id?: number;
    transferDate?: string;
    storeName?: string | undefined;
    numberOfItems?: number;
    requestedValue?: number;
    receivedValue?: number | undefined;
    isDeleted?: boolean;
    acceptedDate?: string | undefined;
    transferType?: string | undefined;
}

export interface ValidateItemQuantityResponse {
    isQuantityValid?: boolean;
    maxValidQuantity?: number;
}

export interface TransportCost {
    id?: number;
    storeNumber?: string | undefined;
    store?: Store2;
    expectedTransportCost?: number;
    actualTransportCost?: number | undefined;
    startDate?: string;
    createdAt?: string;
    createdById?: number;
}

export interface WasteDetails {
    itemId?: number;
    itemNumber?: string | undefined;
    uom?: string | undefined;
    pastDueQty?: number | undefined;
    sampledQty?: number | undefined;
    damagedQty?: number | undefined;
    storeUseQty?: number | undefined;
    isAllowDecimal?: boolean;
}

export interface WasteHeaders {
    id?: number;
    storeNumber?: string | undefined;
    createdDate?: string;
    submittedDate?: string | undefined;
    submittedBy?: string | undefined;
    totalWaste?: number | undefined;
    totalCost?: number | undefined;
    items?: WasteDetails[] | undefined;
}

export interface FactId {
    transactionDay?: number;
    id?: number;
}

export interface NetSales {
    date?: string;
    totalSalePriceNet?: number;
}

export interface VoidedTransaction {
    transactionId?: number;
    productId?: number;
    isVoided?: boolean;
}

export interface ItemRecipe2 {
    itemNumber?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    imageUrlLarge?: string | undefined;
    primaryCategory?: string | undefined;
    familyGroupName?: string | undefined;
    status?: string | undefined;
    uom?: string | undefined;
    pickPackUom?: string | undefined;
    weightNet?: number;
    orderTypes?: number[] | undefined;
    suppliers?: string[] | undefined;
    isBom?: boolean;
    isPosEnabled?: boolean;
    isSaleItem?: boolean;
    isStockItem?: boolean;
    components?: ItemRecipeComponent2[] | undefined;
    itemVolume?: number | undefined;
    tariffCode?: string | undefined;
    sku?: string | undefined;
    vatRate?: number | undefined;
    isDepositFeeItem?: boolean;
    isDepositItem?: boolean;
    depositFeeItemNumber?: string | undefined;
    isAllowPartialUomTransactions?: boolean;
}

export interface ItemRecipeComponent2 {
    itemNumber?: string | undefined;
    quantity?: number;
    weight?: number;
    volume?: number | undefined;
}

export interface KeyValuePair_2OfInt32AndString {
    key?: number;
    value?: string | undefined;
}

export interface KeyValuePair_2OfStringAndString {
    key?: string | undefined;
    value?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class InventoryApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isInventoryApiException = true;

    static isInventoryApiException(obj: any): obj is InventoryApiException {
        return obj.isInventoryApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new InventoryApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
